import React, { useState, useEffect, useContext, useCallback, useMemo, useRef } from "react"
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';


//import { useForm, useWatch, reset} from "react-hook-form";
import { toast, ToastContainer } from "react-toastify"

import { Button } from "../components/ui"
import TablaInicioContainer from "../components/TablaInicioContainer"
import BusquedaFeedback from "../components/BusquedaFeedback"
import BusquedaAvanzadaModal from "../components/BusquedaAvanzadaModal"
import EditExp from "../components/editExp";
import VersionHistory from "../components/VersionHistory";
import PreviewAndDownloadPDFReport from "../components/previewAndDownloadPDFReport";
import PreviewPDF from "../components/PreviewPDF"; //Informe Tecnico Obs

import { AuthContext } from "../context/authContext";
import { useEstadoApp } from "../context/EstadoAppContext";
import { initiateSocketConnection } from "../service/socketio";
import { useGeo } from "../context/GeoContext";
import { useFormContext } from "../context/FormContext";

import { useLocalStorage } from "../hooks/useLocalStorage";
import { useSession } from '../hooks/useSession';

import { optionsPartido } from "../datos/options";

import { REGISTROS_INICIAL } from "../utils/initialStates";
import { TRAMITACIONES_INTERNAS_INICIAL } from "../utils/initialStates";
import { TRAMITACIONES_EXTERNAS_INICIAL } from "../utils/initialStates";
import { SELECTED_REQUISITOS_INICIAL } from "../utils/initialStates";
import { PAGO_MEJORAS_INICIAL } from "../utils/initialStates";
import { PAGO_MICROCREDITOS_INICIAL } from "../utils/initialStates";
import { PAGO_PROYECTOS_INICIAL } from "../utils/initialStates";
import { PAGO_INTERVENCIÓN_SOCIAL_INICIAL } from "../utils/initialStates";
import { PAGO_CAPACITACIONES_INICIAL } from "../utils/initialStates";

const EVENT_NAME = 'redisKeyDeleted';

// Origen "contactos_ong": al entrar desde la lista de obras de una ONG o de un
// partido, al salir hay que volver a donde se vino y no a la pagina de la
// tabla. El destino viaja en localStorage porque InicioPage no sabe de donde se
// vino, y vuelve a la URL para que la pagina lo pueda leer al re-montarse.
//   - ONG:     ongIdOrigen = <id>          -> ?id_ong=<id>
//   - partido: partidoIdOrigen = "<tipo>|<partido>" -> ?tipo_subsidio=&partido=
const volverAContactosONG = (navigate, conExito = false) => {
    const ongId = localStorage.getItem('ongIdOrigen');
    const partidoOrigen = localStorage.getItem('partidoIdOrigen');
    localStorage.removeItem('ongIdOrigen');
    localStorage.removeItem('partidoIdOrigen');

    let destino = '/contactos-ong';
    if (ongId) {
        destino = `/contactos-ong?id_ong=${encodeURIComponent(ongId)}${conExito ? '&edicionExitosa=true' : ''}`;
    } else if (partidoOrigen) {
        const [tipo, partido] = partidoOrigen.split('|');
        const params = new URLSearchParams({ tipo_subsidio: tipo || '', partido: partido || '' });
        if (conExito) params.set('edicionExitosa', 'true');
        destino = `/contactos-ong?${params.toString()}`;
    }
    console.log('Navegando a', destino, 'tras editar la obra desde contactos-ong');
    navigate(destino, { replace: true });
};

// Fuera del componente, al inicio del archivo
/*const TRAMITACIONES_EXTERNAS_INICIAL = [{
    exp: '',
    fecha_salida_convenio: null,
    fecha_firma_convenio: null,
    fecha_salida_reso: null,
    fecha_firma_reso: null
}];
*/

const InicioPageComponente = () => {
    const location = useLocation();
    console.log("REnderizado Memo")

    const navigate = useNavigate();
    const { setItem, removeItem } = useLocalStorage();

    /* inicia States*/
    const { user, userId, role, token } = useContext(AuthContext)

    const { resetForm, updateField, updateFormData, updateFormB, loadFormB, updateFormC, loadFormC, loadField, formA, formB, formC, dirtySections, dirtyFields, resetDirtySections, loadingRef, loadingComplete, updateTramitaciones } = useFormContext();
    const arrayObrasExpedienteRef = useRef([]); // ref para lectura en getFormB_Tramitacion sin stale closure

    const { datosGenerales = {}, tipoSubtipoProyecto = {}, array_obras_expediente = [], habilitarMultiplesPartidos = false, partidosSeleccionados = [], barriosSeleccionados = [], tiposBarrioSeleccionados = [], barriosRENABAPSeleccionados = [], barrioOtroNombres = [] } = formA || {};
    // mantener ref sincronizada para uso en getFormB_Tramitacion sin stale closure
    arrayObrasExpedienteRef.current = array_obras_expediente;
    const expedienteDuplicado = datosGenerales?.expediente_duplicado;
    const expedienteIncompleto = datosGenerales?.expediente_incompleto;
    const obraId = datosGenerales?.id;
    const cg01IdPartidoObra = datosGenerales?.id_partido_obra;
    const { selectedRequisitos = [], tramitacionesExternas = [], tramitacion = {}, observaciones = {} } = formB || {};
    const { reporteEntidad = '', internas = '', tramitacionExterna = '' } = observaciones;
    const { seguimientoObra = {}, arrayPagosMejoras = [], arrayPagosMicrocreditos = [], arrayPagosProyectos = [], arrayPagosIntervencionSocial = [], arrayPagosCapacitaciones = [] } = formC || {};
    const {
        //encargadoRendicion,
        encargadoSeguimiento,
        montoObra,
        //organismoEncargado,
        //empresaContratista,
        fechaInicioObra,
        fechaFinObra,
        observaciones: observacionesSeguimientoObra
        //arrayPagosMejoras, 
        //arrayPagosMicrocreditos, 
        //arrayPagosProyectos
    } = seguimientoObra;

    //console.log("user ---->", user)
    //console.log("userId ---->", userId)
    const { clearFeatures, loadFeaturesForObra, drawnFeatures } = useGeo();

    const {
        isAuthenticated,
        //user,
        login,
        logout,
        authenticatedFetch
    } = useSession();


    const [key, setKey] = useState(null); //17oct2025: para claves eliminadas


    const [new_EditandoId, setNewEditandoId] = useState(""); //---> cambia cuando se de dobleclick en simpleTable (comienza edicion)
    const [recordId, setRecordId] = useState(null); // integer PK de la obra (para API calls que necesitan id numérico)
    const [pendingPromocion, setPendingPromocion] = useState(null); // idPartidoObra pendiente de confirmación de promoción (modal)
    const [showSoloLecturaModal, setShowSoloLecturaModal] = useState(false); // modal al entrar en modo solo_lectura
    const soloLecturaShownRef = useRef(null); // idPartidoObra para el que ya mostramos el modal; se resetea al cambiar de registro
    // Modal al intentar editar una obra mientras el usuario ya está editando otra (edición única por usuario)
    const [edicionCambioPending, setEdicionCambioPending] = useState(null); // { registro, idObraAnterior }
    const confirmaCambioRef = useRef(false); // flag para la llamada post-confirmación del modal
    const newEditandoIdRef = useRef(''); // espejo de new_EditandoId para descartar respuestas stale (race)
    const [beneficiariosReloadKey, setBeneficiariosReloadKey] = useState(0); // fuerza recarga de beneficiarios tras guardar
    //console.log("A- para Socket: new_EditandoId ---->", new_EditandoId)
    // 27FEB25 - Estado para almacenar el formulario consultado por ID
    const [registrosEditados, setRegistrosEditados] = useState({}); // { 'ID': 'user_ID' }
    //console.log("registrosEditados ---->", registrosEditados)

    const [formularioConsultado, setFormularioConsultado] = useState(null);
    console.log("VERIFICAR formularioConsultado ---->", formularioConsultado)

    //9JUL25 - Estado para almacenar las geometrías de la obra
    const [geometries, setGeometries] = useState([]);

    const [busquedaUsuarios, setBusquedaUsuarios] = useState([]);
    //console.log("Usuarios editando el mismo ID", busquedaUsuarios)

    const [arrayEditando, setArrayEditando] = useState([]);
    console.log("CONSULTANDO arrayEditando ---->", arrayEditando)
    /*
    NOTA: se usa cuando se loguea un usuario verificar si hay registros en edicion por otros usuarios.
    el endpoint arrayEditando verifica desde nodejs a redis si hay registros en edicion por otros usuarios.
    luego se actualiza el arrayEditando con los datos de redis.
    */
    console.log("B- para Socket: arrayEditando ---->", arrayEditando)

    const [loading, setLoading] = useState(true);

    //const [reRenderTrigger, setReRenderTrigger] = useState(0);

    // ** ESTADO PRINCIPAL: Maquina de Estados **
    const { estadoAppX, cambiarEstadoApp, origenNavegacion, setOrigenNavegacion, idEtapa1, setIdEtapa1 } = useEstadoApp(); // Usamos nuestro custom hook
    //estado temporal para manejar desde donde viene el estado
    const [deDondeViene, cambiarDeDondeViene] = useState(""); //24-JUL-2025
    //console.log("deDondeViene --->", deDondeViene);

    //24JUL25
    //const [guardarEstados, setGuardarEstados] = useState(false) #5dic25 - se va

    const [valorX, setValorX] = useState("")

    // Ref para evitar re-renders infinitos en useEffect de Etapa II
    const etapa2InitializedRef = useRef(false);
    // Refs para preservar datos de la obra original antes del resetForm
    const originalDataRef = useRef({ area_responsable: '', id_partido_obra: '', organismo_solicitante: '', array_obras_expediente: [] });

    //const [dataSubformTipo, setDataSubformTipo] = useState([]) 
    //console.log("OSO dataSubformTipo ---->", dataSubformTipo)
    //const dataSubformTipoRef = useRef(dataSubformTipo); // ----> NO USAR POR AHORA #26FEB25

    //NUEVO **** 25JUL2025 usar este estado
    const [dataSubformulario, setDataSubformulario] = useState([])

    const [data, setData] = useState([])

    // Búsqueda semántica (resultados sobre obras_semantico en Render)
    const [busquedaSemanticaQuery, setBusquedaSemanticaQuery] = useState("");
    const [resultadosSemanticos, setResultadosSemanticos] = useState(null); // null = sin búsqueda activa
    const [buscandoSemantico, setBuscandoSemantico] = useState(false);
    const [reindexandoSemantico, setReindexandoSemantico] = useState(false);
    const [mostrarFeedback, setMostrarFeedback] = useState(false);
    // Query/params de la última búsqueda para poder relanzar con "todas=1".
    const [ultimaBusquedaSemantica, setUltimaBusquedaSemantica] = useState("");
    const [abrirBusquedaAvanzada, setAbrirBusquedaAvanzada] = useState(false);
    //console.log("DATA de OBRAS, cargar al entrar ---->>",data)

    const [nueva_obra, setNuevaObra] = useState(false)

    const [socket, setSocket] = useState(null);
    //console.log("SOCKET en client", socket)
    const [isSocketConnected, setIsSocketConnected] = useState(false);
    const socketRef = useRef(null);
    const [pendingUpdates, setPendingUpdates] = useState(false);
    const [lastUpdateInfo, setLastUpdateInfo] = useState(null);

    const renderCount = useRef(0);
    const isInitialMount = useRef(true);  //5-agos-2025: estado local, solo para garantizar que modalidad no se resetee en la carga inicial

    const [modoEdicion, setModoEdicion] = useState("manual")
    //console.log("MODO EDICION", modoEdicion)

    const [formularioEsValido, setFormularioEsValido] = useState(false); //15oct2025: 1. Estado para almacenar la validez del formulario hijo
    console.log("VER formularioEsValido ---->", formularioEsValido)

    const [escuchandoLocalData, setEscuchandoLocalData] = useState({});
    console.log("escuchandoLocalData ---->", escuchandoLocalData);

    // Refs to store the data and table reference for the double-click simulation
    const tableInicioRef = useRef(null);
    const [dataForTable, setDataForTable] = useState([]);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [modalAccion, setModalAccion] = useState(null);
    const [cargandoDatos, setCargandoDatos] = useState(false);

    const promotionRef = useRef({
        new_EditandoId: '',
        recordId: null,
        user: '',
        handleEditarRegistro: null,
        getFormC_SeguimientoObra: null,
        setIsEditing: null,
        token: null,
        updateFormData: null
    });

    const [idPartidoObra_leido, setIdPartidoObra_leido] = useState("");

    //const rawToken = localStorage.getItem('token'); //NO USAR desde localstorage, usar el que viene de AuthContext
    //const token = rawToken ? JSON.parse(rawToken) : null;

    //un useEffect cada vez que cambie estadoApp 
    useEffect(() => {
        //solo si es igual a edit_desde_pagos -----> leer desde localStorage
        if (estadoAppX === 'edit_desde_pagos' || estadoAppX === 'edit_desde_proyectos') {
            // Fuente 1: localStorage (patrón existente TablaObras/TablaProyectos)
            // Fuente 2 (fallback): query param ?id_partido_obra= de la URL (navegación con URL visible, ej: /inicio?id_partido_obra=003-001)
            let idPartidoObra = localStorage.getItem('idPartidoObra');
            const isEditingPagos = localStorage.getItem('isEditingPagos');
            const isEditingProyectos = localStorage.getItem('isEditingProyectos');

            if (!idPartidoObra) {
                const params = new URLSearchParams(location.search);
                const qpId = params.get('id_partido_obra');
                if (qpId) {
                    idPartidoObra = qpId;
                    console.log('idPartidoObra leído desde query param de la URL:', idPartidoObra);
                }
            }

            if (idPartidoObra) {
                console.log('idPartidoObra encontrado:', idPartidoObra);
                // Aquí puedes hacer lo que necesites con el idPartidoObra
                setIdPartidoObra_leido(idPartidoObra);
                //Para enviar para Socket, para mostrar en tabla inicio que registro se esta editando
                setNewEditandoId(idPartidoObra)
                //setIsEditing(isEditing)
                setIsEditingPagos(isEditingPagos)
                setIsEditingProyectos(isEditingProyectos)
            } else {
                console.log('No se encontró idPartidoObra en el localStorage');
            }
        } else {
            // Fuera del modo edición: limpiar idPartidoObra_leido para que al refrescarse
            // dataForTable (getObras) el efecto de navegación NO reingrese al expediente
            // (ej. tras guardar y salir de un proyecto migrado por cambio de partido).
            if (idPartidoObra_leido) setIdPartidoObra_leido('');
        }
    }, [location.search]) //Reacciona también a cambios del query param ?id_partido_obra= (ej. post-cambio de partido)


    // Efecto para manejar la navegación desde TablaObras
    useEffect(() => {
        // Solo ejecutar si hay un idPartidoObra_leido y el modo actual es de edición
        // (evita reingresar al expediente tras guardar/cancelar, cuando dataForTable se refresca)
        if (!idPartidoObra_leido) return;
        const esModoEdicion = estadoAppX === 'ediT' || estadoAppX === 'edit_etapa2' || estadoAppX?.startsWith('edit_');
        if (!esModoEdicion) return;

        console.log('🔍 Navegación detectada - id_partido_obra en estado:', idPartidoObra_leido);

        // Función para buscar y editar el registro
        const findAndEditRecord = async () => {
            // 1) Intentar primero con dataForTable (si está disponible)
            let matchingRecord = null;
            if (dataForTable && dataForTable.length > 0) {
                console.log('🔎 Buscando registro con id_partido_obra:', idPartidoObra_leido);
                matchingRecord = dataForTable.find(item => {
                    const match = item.id_partido_obra === idPartidoObra_leido;
                    console.log('Comparando:', item.id_partido_obra, 'con', idPartidoObra_leido, '->', match);
                    return match;
                });
            }

            // 2) Si no se encontró en dataForTable (puede estar vacío o filtrado),
            //    buscar el registro por id_partido_obra vía API para obtener su id (PK)
            if (!matchingRecord) {
                console.warn('⚠️ No se encontró en dataForTable, buscando por lookup:', idPartidoObra_leido);
                try {
                    const headers = {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'X-Socket-Id': socketRef.current?.id || socket?.id || '',
                        ...(token ? { 'Authorization': `Bearer ${token}` } : {})
                    };
                    const res = await fetch(`/api/obras/lookup/${encodeURIComponent(idPartidoObra_leido)}`, { headers });
                    if (res.ok) {
                        const lookup = await res.json();
                        matchingRecord = { id: lookup.id, id_partido_obra: lookup.cg_01_id_partido_obra };
                    }
                } catch (e) {
                    console.error('Error en lookup de obra:', e);
                }

                // Si aún no se encontró y dataForTable está pendiente de cargar, reintentar
                if (!matchingRecord && (!dataForTable || dataForTable.length === 0)) {
                    console.log('⏳ dataForTable vacío y sin lookup, reintentando en 500ms...');
                    setTimeout(findAndEditRecord, 500);
                    return;
                }
            }

            if (matchingRecord) {
                console.log('✅ Editando registro:', matchingRecord);
                handleEditarRegistro(matchingRecord);
            } else {
                console.warn('⚠️ No se pudo resolver el registro con id_partido_obra:', idPartidoObra_leido);
            }
        };

        // Llamar a la función
        findAndEditRecord();

        // Función de limpieza
        return () => {
            console.log('🧹 Limpiando efecto de navegación');
        };
    }, [idPartidoObra_leido, dataForTable]); // Se ejecuta cuando cambia idPartidoObra_leido o dataForTable

    // Inicializar conexión Socket.IO (una sola vez)
    useEffect(() => {
        const s = initiateSocketConnection();
        setSocket(s);
        socketRef.current = s;

        const onConnect = () => {
            console.log('[socket] connected', s.id);
            setIsSocketConnected(true);
        };
        const onDisconnect = () => {
            console.log('[socket] disconnected');
            setIsSocketConnected(false);
        };

        s.on('connect', onConnect);
        s.on('disconnect', onDisconnect);

        // 2. Escuchar el evento
        s.on(EVENT_NAME, (payload) => {
            console.log('Evento recibido:', payload);
            setKey(payload.key);
            //PRO AHORA NO---- >setMessage(`✅ ¡Clave "${payload.key}" eliminada! Notificación recibida a las ${new Date(payload.timestamp).toLocaleTimeString()}`);

            //No recarga las obras, solo chequea el array_editando
            consultar_array_editando();

        });

        return () => {
            s.off('connect', onConnect);
            s.off('disconnect', onDisconnect);
            s.off(EVENT_NAME);
            // NO se cierra el socket acá: es compartido (service/socketio.js
            // reusa la misma conexión) y lo usa el chat de soporte y las
            // burbujas globales, que viven en LayoutPriv. Antes, al salir de
            // Inicio se cortaba la conexión y el chat quedaba sin eventos en
            // vivo. El cierre lo hace LayoutPriv al desmontarse (logout).
        };
    }, []);

    // Escuchar actualizaciones de obras desde el backend
    useEffect(() => {
        if (!socket) return;
        const handler = (payload) => {
            console.log('[socket] obras_changed received', payload);
            setLastUpdateInfo(payload);
            setPendingUpdates(true);
            const who = payload?.by_user ? ` por ${payload.by_user}` : '';
            const obra = payload?.nombre_obra ? ` en "${payload.nombre_obra}"` : '';
            const msgBase = payload?.type === 'created' ? 'Nuevo proyecto disponible' : 'Se modificó proyecto';
            toast.info(`${msgBase}${obra}${who}. Puedes actualizar cuando quieras.`);
        };
        socket.on('obras_changed', handler);
        return () => socket.off('obras_changed', handler);
    }, [socket]);

    const applyPendingUpdates = async () => {
        await getObras(true);
        setPendingUpdates(false);
        setLastUpdateInfo(null);
        toast.success('Datos actualizados');
    };

    useEffect(() => {
        renderCount.current++;
        console.log(`InicioPage RENDER ${renderCount.current}`, {
            registro,
            //estadoApp,
            modoEdicion
        });
    });

    const [bloquear, setBloquear] = useState(false)

    const [editandoInput, setEditandoInput] = useState({
        id_registro: null,
        id_input_editando: null
    });
    console.log("------>CUAL ES EL ID del Input que se está editando??", editandoInput)

    //NOTA: 25-jul-2025: registro va a cambiar de estado cuando se seleccione una row en Simpletable
    // cada vez se haga una edicion.
    //cada vez que se cree una nueva obra  

    //ESTADOS principales
    const [registro, setRegistro] = useState(REGISTROS_INICIAL);
    console.log("REGISTRO --->", registro)
    console.log("nombre_obra en Registro a EDITAR", registro.nombre_obra)

    // Estados de carga para los botones de guardado
    const [isSavingExit, setIsSavingExit] = useState(false);
    const [isSavingCont, setIsSavingCont] = useState(false);

    //Nuevo estado para saber si se está editando un registro
    const [isEditing, setIsEditing] = useState(false);
    console.log("IS EDITING cambia desde TablaInicio", isEditing)

    const [isEditingPagos, setIsEditingPagos] = useState(false);
    console.log("IS EDITING cambia desde TablaPagos", isEditingPagos)
    const [isEditingProyectos, setIsEditingProyectos] = useState(false);
    console.log("IS EDITING cambia desde TablaProyectos", isEditingProyectos)


    const [tramitacionesInternas, setTramitacionesInternas] = useState(TRAMITACIONES_INTERNAS_INICIAL);
    console.log("<---------tramitacionesInternas--->", tramitacionesInternas)

    //ahora se obtiene desde el conxte. Que pasa con setTramitacionesExternas?
    //const [tramitacionesExternas, setTramitacionesExternas] = useState([TRAMITACIONES_EXTERNAS_INICIAL]);

    // Nuevos estados para los textareas:
    const [observacionesReporteEntidad, setObservacionesReporteEntidad] = useState("");
    const [observacionesInternas, setObservacionesInternas] = useState("");

    const [observacionesTramitacionExterna, setObservacionesTramitacionExterna] = useState("");

    // Estados para Requisitos - 12-jun-2025
    //const [selectedRequisitos, setSelectedRequisitos] = useState(SELECTED_REQUISITOS_INICIAL); // USAR este!!!    
    //console.log("selectedRequisitos--->", selectedRequisitos)

    //CAMBIO 4-agos-2025: se quita estado resetRegistro
    //1-agos-2025: estado para formC**

    const [formularioSeguimientoObra, setFormularioSeguimientoObra] = useState(null); //2AGOS25

    //const [encargado_rendicion, setEncargadoRendicion] = useState('');
    //AHORA es encargado de  seguimiento
    const [encargado_seguimiento, setEncargadoSeguimiento] = useState('');

    //const [monto_obraC, setMontoObraC] = useState(registro.monto_obra); // Asumiendo que registro está disponible
    //aceder desde el contexto
    const [monto_obraC, setMontoObraC] = useState(datosGenerales.monto_obra);
    const [organismo_encargado, setOrganismoEncargado] = useState('');
    const [empresa_contratista, setEmpresaContratista] = useState('');
    //estado para fecha_inicio_obra y fecha_fin_obra
    const [fecha_inicio_obra, setFechaInicioObra] = useState(null);
    const [fecha_fin_obra, setFechaFinObra] = useState(null);

    //const [arrayPagosMejoras, setArrayPagosMejoras] = useState([PAGO_MEJORAS_INICIAL]);
    //const [arrayPagosMicrocreditos, setArrayPagosMicrocreditos] = useState([PAGO_MICROCREDITOS_INICIAL]);
    //const [arrayPagosProyectos, setArrayPagosProyectos] = useState([PAGO_PROYECTOS_INICIAL]);

    const [observ_seguimiento_obra, setObservSeguimientoObra] = useState('');

    // Importar el componente DownloadPDFButton
    const DownloadPDFButton = React.lazy(() => import('../components/DownloadPDFButton'));

    // Función para manejar el clic en el botón de ver informe 
    const handlePreviewClick = (obra) => {
        cambiarEstadoApp('previewInformeTecnicoObservaciones', { obra: obra }); //previewInformeTecnico_PRUEBA
    }

    /*--- cierra States ---*/

    //** inicia FUNCIONES */    

    // Ahora la logica de de Validación se hace en inicio page #3dic2025         
    useEffect(() => {
        //desde el context
        const esEncargadoValido = String(datosGenerales.encargado_proyecto ?? '').trim() !== '';
        const esAreaValido = String(datosGenerales.area_responsable ?? '').trim() !== '';
        const esPartidoValido = String(datosGenerales.partido ?? '').trim() !== '';
        const esEstadoValido = String(datosGenerales.estado ?? '').trim() !== '';

        const nombreObraTrimmed = (datosGenerales.nombre_obra ?? '').trim();
        const esNombreObraValido = nombreObraTrimmed !== '' && nombreObraTrimmed !== 'EI -' && nombreObraTrimmed !== 'EII -';

        const camposObligatoriosLlenos =
            esNombreObraValido &&
            esEncargadoValido &&
            esAreaValido &&
            esPartidoValido &&
            esEstadoValido;

        setFormularioEsValido(camposObligatoriosLlenos);

    }, [datosGenerales.nombre_obra, datosGenerales.encargado_proyecto, datosGenerales.area_responsable, datosGenerales.partido, datosGenerales.estado, estadoAppX]);


    const getObras = async () => {

        // Cache del backend deshabilitado; igual pedimos siempre con refresh=1
        // por compatibilidad: una sola llamada con data fresca.
        const url = `/api/obras_inicio?refresh=1`;
        const headers = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'X-Socket-Id': socketRef.current?.id || socket?.id || '',
            ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        }

        try {
            const response = await fetch(url, { headers });
            const result = await response.json();
            console.log("Datos recibidos en getObras:", result); // Verifica los datos
            setData(result);
        } catch (error) {
            console.error('Error al buscar obras:', error);
        } finally {
            setLoading(false);
        }
    }

    // Búsqueda semántica por significado sobre la tabla de Inicio
    const handleBusquedaSemantica = async () => {
        const q = busquedaSemanticaQuery.trim();
        if (!q) {
            setResultadosSemanticos(null);
            return;
        }
        setBuscandoSemantico(true);
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Socket-Id': socketRef.current?.id || socket?.id || '',
                ...(token ? { 'Authorization': `Bearer ${token}` } : {})
            };
            const response = await fetch(`/api/obras/busqueda_semantica?q=${encodeURIComponent(q)}`, { headers });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            setResultadosSemanticos(await response.json());
            setUltimaBusquedaSemantica(`q=${encodeURIComponent(q)}`);
        } catch (error) {
            console.error('Error en búsqueda semántica:', error);
            toast.error('Error en la búsqueda semántica');
        } finally {
            setBuscandoSemantico(false);
        }
    }

    // Búsqueda avanzada guiada: recibe un URLSearchParams con los criterios estructurados
    // y un texto libre opcional. Reutiliza el endpoint semántico (query params + q).
    const handleBusquedaAvanzada = async (params, resumen) => {
        setBuscandoSemantico(true);
        setAbrirBusquedaAvanzada(false);
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Socket-Id': socketRef.current?.id || socket?.id || '',
                ...(token ? { 'Authorization': `Bearer ${token}` } : {})
            };
            const url = `/api/obras/busqueda_semantica?${params.toString()}`;
            const response = await fetch(url, { headers });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const res = await response.json();
            setResultadosSemanticos(res);
            setUltimaBusquedaSemantica(params.toString());
            setBusquedaSemanticaQuery(resumen || params.get('q') || '');
        } catch (error) {
            console.error('Error en búsqueda avanzada:', error);
            toast.error('Error en la búsqueda avanzada');
        } finally {
            setBuscandoSemantico(false);
        }
    }

    // Relanza la última búsqueda semántica/avanzada pidiendo "todas=1" (sin el corte de 20).
    const handleVerTodas = async () => {
        const base = ultimaBusquedaSemantica || `q=${encodeURIComponent(busquedaSemanticaQuery || '')}`;
        if (!base) return;
        const sep = base.includes('?') ? '&' : (base.includes('=') ? '&' : '?');
        const url = `/api/obras/busqueda_semantica?${base}${sep}todas=1`;
        setBuscandoSemantico(true);
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Socket-Id': socketRef.current?.id || socket?.id || '',
                ...(token ? { 'Authorization': `Bearer ${token}` } : {})
            };
            const response = await fetch(url, { headers });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const res = await response.json();
            setResultadosSemanticos(res);
        } catch (error) {
            console.error('Error al listar todas las obras:', error);
            toast.error('Error al listar todas las obras');
        } finally {
            setBuscandoSemantico(false);
        }
    }

    const handleReindexarSemantico = async () => {
        setReindexandoSemantico(true);
        const confirmar = window.confirm(
            "Esto reindexa TODAS las obras en la base pgvector del buscador semántico.\n" +
            "¿Deseás continuar?"
        );
        if (!confirmar) {
            setReindexandoSemantico(false);
            return;
        }
        try {
            const headers = {
                'Content-Type': 'application/json',
                ...(token ? { 'Authorization': `Bearer ${token}` } : {})
            };
            const response = await fetch(`/api/obras/indexar_semantico?reset=true`, { method: 'POST', headers });
            if (!response.ok) {
                const err = await response.json().catch(() => ({}));
                throw new Error(err.details || `HTTP ${response.status}`);
            }
            const data = await response.json();
            toast.success(`Buscador reindexado: ${data.obras} obras (${data.estado?.con_emb ?? 0} con embedding)`);
        } catch (error) {
            console.error('Error al reindexar buscador semántico:', error);
            toast.error(`Error al reindexar el buscador semántico: ${error.message}`);
        } finally {
            setReindexandoSemantico(false);
        }
    }

    // Valorar un resultado de la búsqueda semántica (1 = 👍, -1 = 👎)
    const handleValorar = async (id_obra, valoracion) => {
        const q = busquedaSemanticaQuery.trim();
        if (!q) return;
        const sim = resultadosSemanticos?.find((r) => String(r.id_partido_obra) === String(id_obra))?.similarity ?? null;
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Socket-Id': socketRef.current?.id || socket?.id || '',
                ...(token ? { 'Authorization': `Bearer ${token}` } : {})
            };
            const response = await fetch('/api/obras/busqueda_semantica_feedback', {
                method: 'POST',
                headers,
                body: JSON.stringify({ q, id_obra, valoracion, sim }),
            });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            toast.success(valoracion === 1 ? 'Valoración guardada 👍' : 'Valoración guardada 👎');
        } catch (error) {
            console.error('Error al valorar:', error);
            toast.error('Error al guardar la valoración');
        }
    };

    // Con búsqueda semántica activa: filtra la lista ORIGINAL de Inicio (con todos sus
    // campos) por los id_obra que devolvió el response, ordenados por similitud.
    const dataSemantica = useMemo(() => {
        if (!resultadosSemanticos) return null;
        const sim = new Map(
            resultadosSemanticos.map((r) => [String(r.id_partido_obra), r.similarity ?? 0])
        );
        return data
            .filter((o) => sim.has(String(o.id_partido_obra)))
            .sort((a, b) => (sim.get(String(b.id_partido_obra)) - sim.get(String(a.id_partido_obra))));
    }, [resultadosSemanticos, data]);
    // definir getRegistroById para traer todos los datos del registro
    const getRegistroById = async (id) => {
        const url = `/api/obras/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'X-Socket-Id': socketRef.current?.id || socket?.id || '',
            ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        }

        try {
            const response = await fetch(url, { headers });
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error al buscar registro:', error);
            return null;
        }
    }


    const getFormB_Tramitacion = async () => {
        setFormularioConsultado(null); // Limpia formulario previo
        //console.log("Entando en getFormB_Tramitacion")

        const idRequerido = new_EditandoId; // captura el id solicitado para descartar respuestas stale
        const urlFormB = `/api/form_b_tramitacion/${idRequerido}`;
        const headers = {
            'Content-Type': 'application/json',
            ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        }

        try {
            const response = await fetch(urlFormB, { headers }); // Petición GET al nuevo endpoint, usando el new_EditandoId
            if (idRequerido !== newEditandoIdRef.current) return; // respuesta de otra obra: descartar

            if (!response.ok) {
                if (response.status === 404) {
                    //setMensajeConsulta('Formulario no encontrado.'); // Mensaje específico si no se encuentra (404)
                    console.log("Formulario no encontrado")
                } else {
                    throw new Error(`Error HTTP! status: ${response.status}`); // Otros errores HTTP
                }
                return; // Sale de la función si hubo error en la respuesta
            }

            const data = await response.json(); // Parsea la respuesta JSON (que debe ser el formulario)
            if (idRequerido !== newEditandoIdRef.current) return; // respuesta stale: descartar
            //ANTES (ya no pasamos  como props) ----> setFormularioConsultado(data); // Guarda el formulario en el estado para mostrarlo // ---B--27feb
            //setMensajeConsulta('Formulario encontrado y cargado.'); // Mensaje de éxito

            // Actualizar el contexto con los datos recibidos
            // Los rows de Tramitación Externa deben coincidir 1:1 con array_obras_expediente.
            // Por cada expediente de formA se busca su correspondiente en BD para preservar
            // fechas: primero por exp, luego por objeto (evita duplicados). Los items de BD
            // no referenciados por formA se descartan.
            // Siempre usar datos de BD tal cual (nunca perder fechas por race condition).
            // Luego, si el ref está poblado, reordenar 1:1 con array_obras_expediente.
            const loadedBD = (Array.isArray(data.tramitacion_externa_jsonb)
                ? data.tramitacion_externa_jsonb
                : []).filter(t => t.exp && t.objeto);
            // Toda fila necesita un id propio: TramitacionExternaRow lo usa para resolver
            // el update y formB_Tramitacion descarta la edicion si no lo tiene. El id es
            // artificial (la API no lo manda) y leer arrayObrasExpedienteRef despues del
            // await es una carrera: si da [] se instalaban filas sin id y perderian toda
            // fecha elegida, en silencio. Por eso se asigna siempre, con o sin ref.
            let tramitacionesExternas = loadedBD.map((t, i) => ({ ...t, id: `exp-${t.exp}-${i}` }));
            const expedientes = (arrayObrasExpedienteRef.current || []).filter(e => e && e.expediente_o);

            if (expedientes.length > 0) {
                // Índices de BD: por exp+objeto (preferido) y por objeto (fallback)
                const bdByExp = new Map();
                const bdByObjeto = new Map();
                loadedBD.forEach(t => {
                    const expKey = t.exp && t.objeto ? `${t.exp}|${t.objeto}` : t.exp;
                    if (t.exp) bdByExp.set(expKey, t);
                    if (!t.objeto) return;
                    const current = bdByObjeto.get(t.objeto);
                    if (!current) {
                        bdByObjeto.set(t.objeto, t);
                    } else {
                        const curHasDates = current.fecha_salida_convenio || current.fecha_firma_convenio || current.fecha_salida_reso || current.fecha_firma_reso;
                        const newHasDates = t.fecha_salida_convenio || t.fecha_firma_convenio || t.fecha_salida_reso || t.fecha_firma_reso;
                        if (!curHasDates && newHasDates) {
                            bdByObjeto.set(t.objeto, t);
                        }
                    }
                });
                const usados = new Set();

                tramitacionesExternas = expedientes.map((obraExp, idx) => {
                    const exp = obraExp.expediente_o;
                    const objeto = obraExp.objeto_o;

                    // Intentar match por exp+objeto (evita colisión cuando dos expedientes comparten exp, ej. Proyecto y Adenda)
                    const matchKey = exp && objeto ? `${exp}|${objeto}` : exp;
                    let match = bdByExp.get(matchKey);
                    if (match && !usados.has(match)) {
                        usados.add(match);
                        return { ...match, id: `exp-${exp}-${idx}`, exp, objeto };
                    }

                    // Fallback: match por objeto
                    match = objeto ? bdByObjeto.get(objeto) : null;
                    if (match && !usados.has(match)) {
                        usados.add(match);
                        return { ...match, id: `exp-${exp}-${idx}`, exp, objeto };
                    }

                    // Sin match en BD → crear vacío
                    return {
                        id: `exp-${exp}-${idx}`,
                        exp,
                        objeto,
                        fecha_salida_convenio: null,
                        fecha_firma_convenio: null,
                        fecha_salida_reso: null,
                        fecha_firma_reso: null,
                    };
                });
            }

            loadFormB({
                selectedRequisitos: data.documentos_seleccionados || {},
                tramitacion: data.tramitacion_interna_jsonb || {},
                tramitacionesExternas,
                observaciones: {
                    reporteEntidad: data.observaciones_reporte || '',
                    internas: data.observaciones_internas || '',
                    tramitacionExterna: data.observaciones_externas || ''
                },
                internasHistorico: Array.isArray(data.observaciones_internas_historico)
                    ? data.observaciones_internas_historico
                    : [],
                expedienteProyecto: Array.isArray(data.expediente_proyecto)
                    ? data.expediente_proyecto
                    : [],
                orgDocsExpanded: Array.isArray(data.expediente_proyecto) && data.expediente_proyecto.length > 0
                    ? data.expediente_proyecto[0].org_docs_expanded || false
                    : false
            });
        } catch (error) {
            console.error('Error al buscar formulario por ID:', error);
            //setMensajeConsulta('Error al buscar el formulario. Intente nuevamente.'); // Mensaje genérico de error
        }
    }

    //02-agos-2025 llamada a seguimieento de obra, por id editando
    const getFormC_SeguimientoObra = async () => {
        //setFormularioSeguimientoObra(null); // Limpia formulario previo

        const idRequerido = new_EditandoId; // captura el id solicitado para descartar respuestas stale
        const urlFormC = `/api/form_c_seguimiento_obra/${idRequerido}`;
        const headers = {
            'Content-Type': 'application/json',
            ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        }

        try {
            const response = await fetch(urlFormC, { headers });
            if (idRequerido !== newEditandoIdRef.current) return; // respuesta de otra obra: descartar

            if (!response.ok) {
                if (response.status === 404) {
                    console.log("Datos para FormC no encontrados")
                    if (idRequerido !== newEditandoIdRef.current) return; // stale: no aplicar defaults sobre otra obra
                    // Cargar defaults sin marcar dirtySections (como formB 404)
                    loadFormC({
                        seguimientoObra: {
                            //encargadoRendicion: '',
                            encargadoSeguimiento: '',
                            montoObra: '',
                            //organismoEncargado: '',
                            //empresaContratista: '',
                            fechaInicioObra: '',
                            fechaFinObra: '',
                            observaciones: ''
                        },
                        arrayPagosMejoras: [...PAGO_MEJORAS_INICIAL],
                        arrayPagosMicrocreditos: [...PAGO_MICROCREDITOS_INICIAL],
                        arrayPagosProyectos: [...PAGO_PROYECTOS_INICIAL],
                        arrayPagosIntervencionSocial: [...PAGO_INTERVENCIÓN_SOCIAL_INICIAL],
                        arrayPagosCapacitaciones: [...PAGO_CAPACITACIONES_INICIAL]
                    });
                } else {
                    throw new Error(`Error HHTP! status: ${response.status}`);
                }
                return;
            }

            const data = await response.json();
            if (idRequerido !== newEditandoIdRef.current) return; // respuesta stale: descartar

            // Procesar arrays de pagos (vienen directamente desde form_c_pagos child table)
            const procesarArrayPagos = (pagosArray, defaultArray) => {
                if (!pagosArray || !Array.isArray(pagosArray) || pagosArray.length === 0) {
                    return [...defaultArray];
                }
                return pagosArray.map(pago => ({
                    ...pago,
                    esPagoEfectivo: !!(pago.monto || pago.porc_pago || pago.fecha_pago)
                }));
            };

            // Preparar los datos para el contexto
            const formCData = {
                seguimientoObra: {
                    encargadoSeguimiento: data.encargado_seguimiento || '',
                    montoObra: data.monto_obra || '',
                    fechaInicioObra: data.fecha_inicio_obra || '',
                    fechaFinObra: data.fecha_fin_obra || '',
                    observaciones: data.observ_seguimiento_obra || ''
                },
                arrayPagosMejoras: procesarArrayPagos(data.arrayPagosMejoras, PAGO_MEJORAS_INICIAL),
                arrayPagosMicrocreditos: procesarArrayPagos(data.arrayPagosMicrocreditos, PAGO_MICROCREDITOS_INICIAL),
                arrayPagosProyectos: procesarArrayPagos(data.arrayPagosProyectos, PAGO_PROYECTOS_INICIAL),
                arrayPagosIntervencionSocial: procesarArrayPagos(data.arrayPagosIntervencionSocial, PAGO_INTERVENCIÓN_SOCIAL_INICIAL),
                arrayPagosCapacitaciones: procesarArrayPagos(data.arrayPagosCapacitaciones, PAGO_CAPACITACIONES_INICIAL),
                // Porcentajes parciales capturados para habilitación de pagos (convertir a número)
                porcentaje_parcial_2do_pago: data.porcentaje_parcial_2do_pago ? parseFloat(data.porcentaje_parcial_2do_pago) : null,
                porcentaje_parcial_3er_pago: data.porcentaje_parcial_3er_pago ? parseFloat(data.porcentaje_parcial_3er_pago) : null,
                // Mediciones de obra
                arrayMediciones: data.array_mediciones || [],
                arrayMejorasEtapaI: data.array_mejoras_etapa_i || [],
                arrayMejorasEtapaII: data.array_mejoras_etapa_ii || [],
                arrayCircuitoAdmin: data.array_circuito_admin || []
            };

            console.log('LEON Datos a guardar en el contexto (FormC):', formCData);
            loadFormC(formCData);

        } catch (err) {
            console.log('Error al buscar Seguimiento de Obra por ID:', err);
        }
    }

    const consultar_array_editando = async () => {
        console.log("CONSULTANDO arrayEditando")
        const url = `/api/arrayEditando`;
        const headers = { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' }

        try {
            const response = await fetch(url, { headers });
            const result = await response.json();
            console.log("Datos recibidos en getObras:", result); // Verifica los datos
            if (Array.isArray(result)) {
                setArrayEditando(result);
            } else {
                console.log("No hay datos en arrayEditando")
                setArrayEditando([]);
            }
        } catch (error) {
            console.error('Error al buscar obras:', error);
        }
    }

    // 15oct25 VERIFICAR (para socket.io)
    const quitarIdEdicion = (id) => {
        const idToUse = id || new_EditandoId;
        console.log("QUITAR este ID con Socket.io", { id, new_EditandoId, idToUse, user, connected: isSocketConnected })

        if (!idToUse) {
            console.log("NO HAY ID para quitar_id_edicion")
            return
        }

        const socketToUse = socket || socketRef.current;
        if (socketToUse && isSocketConnected) {
            socketToUse.emit("quitar_id_edicion", idToUse, user)
        } else if (socketToUse) {
            console.log("socket exists but not connected, attempting emit anyway")
            socketToUse.emit("quitar_id_edicion", idToUse, user)
        } else {
            console.log("NO SOCKET AVAILABLE to quitar_id_edicion")
        }
    }

    const handleLiberarEdicion = useCallback((id_registro) => {
        const socketToUse = socket || socketRef.current;
        if (socketToUse && isSocketConnected) {
            socketToUse.emit("liberar_edicion", id_registro);
        }
    }, [socket, isSocketConnected])

    const handleSoftDelete = useCallback(async (id_partido_obra) => {
        try {
            const response = await fetch(`/api/obras/${id_partido_obra}/soft-delete`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token ? { 'Authorization': `Bearer ${token}` } : {})
                }
            });
            const result = await response.json();
            if (result.success) {
                getObras(true);
            } else {
                alert(`Error: ${result.message}`);
            }
        } catch (error) {
            console.error('Error al dar de baja obra:', error);
            alert('Error al dar de baja la obra');
        }
    }, [token]);

    const [mostrandoCancelConfirm, setMostrandoCancelConfirm] = useState(false);

    const hasUnsavedChanges = Object.values(dirtySections).some(v => v);

    const ejecutarCancelacion = () => {
        setModalAccion("cancelar");
        setCargandoDatos(false);
        setIdPartidoObra_leido(''); // salir del modo edición: no reingresar al expediente
        setTimeout(() => {
            if (estadoAppX === "nuevo" || estadoAppX === "nuevo_etapa2" || estadoAppX === "ediT" || estadoAppX === "edit_etapa2") {
                if (estadoAppX === "ediT" || estadoAppX === "edit_etapa2") {
                    quitarIdEdicion(datosGenerales.id_partido_obra)
                    localStorage.removeItem('idPartidoObra');
                }

                cambiarEstadoApp("inicial");

                localStorage.removeItem('idPartidoObra');
                clearFeatures();
                setBloquear(false);

                // Limpiar el query param ?id_partido_obra= de la URL al cancelar
                const url = new URL(window.location.href);
                if (url.searchParams.has('id_partido_obra')) {
                    url.searchParams.delete('id_partido_obra');
                    window.history.replaceState({}, '', url.pathname + url.search);
                }

            } else if (estadoAppX === "edit_desde_pagos" || estadoAppX === "edit_desde_proyectos" || estadoAppX === "nuevo_etapa2") {

                // Liberar SOLO la edición de este usuario (quitar_id_edicion usa user actual + id),
                // sin afectar la edición de otro usuario (A) que siga editando el registro.
                quitarIdEdicion(new_EditandoId);

                cambiarEstadoApp("inicial");

                if (origenNavegacion === "tramitaciones") {
                    const tabOrigen = localStorage.getItem('lastActiveTab');
                    console.log('Navegando a /tramitaciones con tab:', tabOrigen);
                    if (tabOrigen) {
                        console.log("TIENE tabOrigen")
                        navigate(`/tramitaciones`, {
                            replace: true
                        });
                    } else {
                        console.log("NO TIENE tabOrigen")
                        navigate(`/inicio`, { replace: true });
                    }
                } else if (origenNavegacion === "analisis_pagos") {
                    // Vuelve a la página de Análisis de Pagos (sin el query param de edición)
                    navigate(`/analisis-pagos`, { replace: true });
                } else if (origenNavegacion === "obras_sin_pagos") {
                    // Vuelve a Obras sin pagos (sin el query param de edición)
                    navigate(`/obras-sin-pagos`, { replace: true });
                } else if (origenNavegacion === "contactos_ong") {
                    // Vuelve a la lista de obras de la ONG, sin el query param de edición
                    volverAContactosONG(navigate);
                } else if (location.search) {
                    // Cualquier otro origen: limpiar el query param (ej: ?id_partido_obra=) para no reingresar a la obra al re-montar
                    navigate(`/inicio`, { replace: true });
                }
                clearFeatures();
                localStorage.removeItem('idPartidoObra');
                localStorage.removeItem('isEditingPagos');
                localStorage.removeItem('isEditingProyectos');
                setBloquear(false);
            }
            setModalAccion(null);
        }, 300);
    };

    const toggle = () => {
        if (estadoAppX === "inicial") {
            cambiarEstadoApp("nuevo");
            clearFeatures();
        } else if (hasUnsavedChanges && role === 'admin') {
            setMostrandoCancelConfirm(true);
        } else {
            ejecutarCancelacion();
        }
    };

    //5-agos-205: resetear a valores iniciales y refrescar tabla
    useEffect(() => {
        if (estadoAppX === "inicial") {
            console.log("LIMPIA newEditandoId")

            resetForm();

            localStorage.removeItem('idPartidoObra');

            setNewEditandoId(""); //si es "inicial" ---> limpiar el id editando
            setRegistrosEditados({});

            // Refrescar tabla para ver cambios guardados
            getObras();

            setIsEditing(false);
            setIsEditingPagos(false);
            setIsEditingProyectos(false);

            isInitialMount.current = true;
            //CAMBIO 4-agos-2025: se quita ---->setRegistro(resetRegistro); 
            setRegistro({ ...REGISTROS_INICIAL });
            //reset form B
            //setSelectedRequisitos({...SELECTED_REQUISITOS_INICIAL}); //donde se resetea usando el context?

            //setTramitacionesExternas([...TRAMITACIONES_EXTERNAS_INICIAL]);//donde se resetea usando el context?
            setTramitacionesInternas({ ...TRAMITACIONES_INTERNAS_INICIAL });
            setObservacionesReporteEntidad("");
            setObservacionesInternas("");

            //reset form C
            setEncargadoSeguimiento("");
            //setEncargadoRendicion(""); //ya no va lista de encargado de rendicion
            setMontoObraC("");
            //setOrganismoEncargado(""); //ya no va lista de organismos
            //setEmpresaContratista(""); //ya no va lista de empresas contratistas
            setFechaInicioObra("");
            setFechaFinObra("");
            //PENDIENTE: como resetearlos, ahora en el contexto
            //setArrayPagosMejoras([...PAGO_MEJORAS_INICIAL]);
            //setArrayPagosMicrocreditos([...PAGO_MICROCREDITOS_INICIAL]);
            //setArrayPagosProyectos([...PAGO_PROYECTOS_INICIAL]);

            setObservSeguimientoObra("");
        } else if (estadoAppX === "nuevo") {
            // Al crear una obra nueva los formularios formB/formC
            // deben iniciar SIEMPRE vacíos con los defaults, aunque vengamos de editar otra
            // obra con datos cargados (evita que los pagos de una carga anterior "persistan").
            // (nuevo_etapa2 se resetea en su propio efecto, tras resetForm.)
            loadFormB({
                selectedRequisitos: {},
                tramitacion: {},
                tramitacionesExternas: [],
                observaciones: {
                    reporteEntidad: '',
                    internas: '',
                    tramitacionExterna: ''
                },
                internasHistorico: [],
                expedienteProyecto: [],
                orgDocsExpanded: false
            });
            loadFormC({
                seguimientoObra: {
                    encargadoSeguimiento: '',
                    montoObra: '',
                    fechaInicioObra: '',
                    fechaFinObra: '',
                    observaciones: ''
                },
                arrayPagosMejoras: [...PAGO_MEJORAS_INICIAL],
                arrayPagosMicrocreditos: [...PAGO_MICROCREDITOS_INICIAL],
                arrayPagosProyectos: [...PAGO_PROYECTOS_INICIAL],
                arrayPagosIntervencionSocial: [...PAGO_INTERVENCIÓN_SOCIAL_INICIAL],
                arrayPagosCapacitaciones: [...PAGO_CAPACITACIONES_INICIAL],
                porcentaje_parcial_2do_pago: null,
                porcentaje_parcial_3er_pago: null,
                arrayMediciones: [],
                arrayMejorasEtapaI: [],
                arrayMejorasEtapaII: [],
                arrayCircuitoAdmin: []
            });
        }
    }, [estadoAppX, loadFormB, loadFormC])

    //useEffect para deDondeViene - 24JUL2025
    useEffect(() => {
        console.log("deDondeViene", deDondeViene)
        if (estadoAppX === "nuevo" || estadoAppX === "nuevo_etapa2") {
            cambiarDeDondeViene("nuevo")
        } else if (estadoAppX === "ediT" || estadoAppX === "edit_etapa2") {
            cambiarDeDondeViene("ediT")
        } else if (estadoAppX === "inicial") {
            cambiarDeDondeViene("")
        } else if (estadoAppX === "edit_desde_pagos") {
            cambiarDeDondeViene("edit_desde_pagos")
        } else if (estadoAppX === "edit_desde_proyectos") {
            cambiarDeDondeViene("edit_desde_proyectos")
        }
    }, [estadoAppX])

    //useEffect para manejar la creación de Etapa II / Rendición
    useEffect(() => {
        if (estadoAppX === 'nuevo_etapa2' && idEtapa1 && !etapa2InitializedRef.current) {
            console.log('Iniciando configuración de Rendición, vinculando a expediente:', idEtapa1);

            etapa2InitializedRef.current = true;

            // Preservar datos de la obra original ANTES de resetForm
            const datosGeneralesActual = formA?.datosGenerales || {};
            originalDataRef.current = {
                area_responsable: datosGeneralesActual.area_responsable || '',
                id_partido_obra: datosGeneralesActual.id_partido_obra || '',
                organismo_solicitante: datosGeneralesActual.organismo_solicitante || '',
                array_obras_expediente: Array.isArray(datosGeneralesActual.array_obras_expediente)
                    ? datosGeneralesActual.array_obras_expediente
                    : (Array.isArray(formA?.array_obras_expediente) ? formA?.array_obras_expediente : [])
            };

            resetForm();

            // Tras resetForm (que deja formC en {}), inicializar formB/formC con defaults
            // para que la nueva etapa/r endición arranque con los pagos en blanco.
            loadFormB({
                selectedRequisitos: {},
                tramitacion: {},
                tramitacionesExternas: [],
                observaciones: {
                    reporteEntidad: '',
                    internas: '',
                    tramitacionExterna: ''
                },
                internasHistorico: [],
                expedienteProyecto: [],
                orgDocsExpanded: false
            });
            loadFormC({
                seguimientoObra: {
                    encargadoSeguimiento: '',
                    montoObra: '',
                    fechaInicioObra: '',
                    fechaFinObra: '',
                    observaciones: ''
                },
                arrayPagosMejoras: [...PAGO_MEJORAS_INICIAL],
                arrayPagosMicrocreditos: [...PAGO_MICROCREDITOS_INICIAL],
                arrayPagosProyectos: [...PAGO_PROYECTOS_INICIAL],
                arrayPagosIntervencionSocial: [...PAGO_INTERVENCIÓN_SOCIAL_INICIAL],
                arrayPagosCapacitaciones: [...PAGO_CAPACITACIONES_INICIAL],
                porcentaje_parcial_2do_pago: null,
                porcentaje_parcial_3er_pago: null,
                arrayMediciones: [],
                arrayMejorasEtapaI: [],
                arrayMejorasEtapaII: [],
                arrayCircuitoAdmin: []
            });

            // Usar datos preservados para configurar la nueva etapa
            const { area_responsable, id_partido_obra, organismo_solicitante, array_obras_expediente } = originalDataRef.current;
            const esMicrocreditos = area_responsable === 'ÁREA DE MICROCRÉDITOS';

            setTimeout(() => {
                if (esMicrocreditos) {
                    updateField('formA', 'datosGenerales', 'tipo_microcredito', 'EXP_RENDIC');
                } else {
                    updateField('formA', 'datosGenerales', 'etapa', 2);
                }
                updateField('formA', 'datosGenerales', 'id_etapa1_referencia', id_partido_obra);
                updateField('formA', 'datosGenerales', 'modalidad', esMicrocreditos ? '' : 'etapa II');

                let nombreObra = '';
                if (esMicrocreditos) {
                    const expProyecto = array_obras_expediente.find(e => e && e.objeto_o === 'Proyecto');
                    const nroExp = expProyecto?.expediente_o || '';
                    const ultDigitos = nroExp.replace(/\D/g, '').slice(-4);
                    nombreObra = `REND - ${organismo_solicitante} - ${ultDigitos}`.trim();
                } else {
                    nombreObra = 'EII - ';
                }
                updateField('formA', 'datosGenerales', 'nombre_obra', nombreObra);

                const partidoId = id_partido_obra?.toString().substring(0, 3);
                if (partidoId) {
                    const partidoNum = parseInt(partidoId, 10);
                    updateField('formA', 'datosGenerales', 'partido', partidoNum);

                    const partidoEncontrado = optionsPartido.find(p => p.value === partidoId || p.value === partidoNum.toString());
                    if (partidoEncontrado) {
                        updateField('formA', 'datosGenerales', 'partido_nombre', partidoEncontrado.label);
                    }
                }

                updateField('formA', 'datosGenerales', 'area_responsable', area_responsable || 'ÁREA DE MEJORAS');
                console.log('Área responsable establecida:', area_responsable);
            }, 0);
        }

        if (estadoAppX !== 'nuevo_etapa2') {
            etapa2InitializedRef.current = false;
        }
    }, [estadoAppX, idEtapa1, resetForm, updateField, loadFormB, loadFormC])

    //NOTA 19-agos-2025: mantener para MIGRACION
    //cuando se hace dobleclick sobre la fila de la tabla cambia el estado a "ediT"

    //---> se pasa a TablaInicioContainer
    // esta queda #5dic25 - actualiza con los datos de registro solo en formA.
    //NOTA: formB y formC se actualizan llamando a las funciones por formulario
    const handleEditarRegistro = useCallback(async (registroE, isEditing = true) => {
        // Activar bloqueo de dirtySections durante carga (se desactiva automáticamente
        // en el useEffect de FormProvider luego de que todos los efectos hijos corran)
        loadingRef.current = true;
        setCargandoDatos(true);

        // Edición única por usuario: si el usuario ya está editando otra obra y esta edición
        // corresponde a una obra distinta, pedir confirmación (modal) antes de reemplazarla.
        if (!confirmaCambioRef.current) {
            const userClean = user ? String(user).replace(/"/g, '') : '';
            const obraActual = (Array.isArray(arrayEditando) ? arrayEditando : [])
                .find(o => o && o.user_edit && String(o.user_edit).replace(/"/g, '') === userClean);
            if (obraActual && obraActual.id_edit && obraActual.id_edit !== registroE.id_partido_obra) {
                // Post-cambio de partido: el original quedó dado de baja, se reemplaza la
                // edición directamente (sin modal de confirmación de cambio de obra).
                const cambioPartidoFlag = localStorage.getItem('cambioPartidoNuevo');
                if (cambioPartidoFlag === String(registroE.id_partido_obra)) {
                    localStorage.removeItem('cambioPartidoNuevo');
                    quitarIdEdicion(obraActual.id_edit);
                    setNewEditandoId(registroE.id_partido_obra);
                } else {
                    setEdicionCambioPending({ registro: registroE, idObraAnterior: obraActual.id_edit });
                    loadingRef.current = false;
                    setCargandoDatos(false);
                    return;
                }
            }
        } else {
            confirmaCambioRef.current = false;
        }

        // Extraer arrays y campos de selección múltiple del registroE

        //obtner id de registroE y usarlo para traer el resto de los datos del registro
        const { id } = registroE;
        setRecordId(id); // guardar integer PK para uso en recargar (promoción)

        // Mostrar el id_partido_obra en la URL (query param) al editar, desde cualquier origen.
        // replaceState actualiza la URL sin recargar ni re-renderizar/remontar la página.
        if (registroE.id_partido_obra) {
            const url = new URL(window.location.href);
            url.searchParams.set('id_partido_obra', registroE.id_partido_obra);
            window.history.replaceState({}, '', url.pathname + url.search);
        }

        let registroCompleto;
        try {
            registroCompleto = await getRegistroById(id);
        } catch (error) {
            console.error('Error al cargar registro completo:', error);
            // No desbloquear loadingRef aquí — el efecto en FormProvider lo hará
            // en el próximo render (cuando detecte que no hay id nuevo o falle).
            // Pero mejor lo liberamos explícitamente:
            loadingRef.current = false;
            setCargandoDatos(false);
            return;
        }
        //destructurin de registroCompleto
        const {
            array_tipo_subtipo_proyecto,
            array_obras_expediente,
            habilitar_multiples_partidos,
            partidos_multiples_jsonb,
            barrios_rppvap_multiples_jsonb,
            tipos_barrio_jsonb,
            barrios_renabap_multiples_jsonb,
            barrio_otro_nombre_jsonb,
            tipo_microcredito,
            ...restoDatos
        } = registroCompleto;
        //actualizar formA con updateFormData
        updateFormData('formA', {
            datosGenerales: {
                ...restoDatos,
                tipo_microcredito: tipo_microcredito || null,
            },
            tipoSubtipoProyecto: Array.isArray(array_tipo_subtipo_proyecto)
                ? array_tipo_subtipo_proyecto
                : [{ tipo: '', subtipo: '', cantidad: '', unidad: '' }],
            array_obras_expediente: Array.isArray(array_obras_expediente)
                ? array_obras_expediente
                : [],
            habilitarMultiplesPartidos: habilitar_multiples_partidos || false,
            partidosSeleccionados: partidos_multiples_jsonb || [],
            barriosSeleccionados: barrios_rppvap_multiples_jsonb || [],
            tiposBarrioSeleccionados: tipos_barrio_jsonb || [],
            barriosRENABAPSeleccionados: barrios_renabap_multiples_jsonb || [],
            barrioOtroNombres: barrio_otro_nombre_jsonb || (restoDatos.barrio_otro_nombre ? [restoDatos.barrio_otro_nombre] : [])
        });

        // Los datos del formulario ya se cargaron: ocultar el modal de carga
        setCargandoDatos(false);


        /*
        const {
            array_tipo_subtipo_proyecto,
            array_obras_expediente,
            habilitar_multiples_partidos,
            partidos_multiples_jsonb,
            barrios_rppvap_multiples_jsonb,
            tipos_barrio_jsonb,
            barrios_renabap_multiples_jsonb,
            ...restoDatos
        } = registroE;        

        // Actualizar el contexto con los datos del registro a editar
        //console.log('Actualizando con datos:', registroE);
        //console.log('DEBUG - tipos_barrio_jsonb:', tipos_barrio_jsonb);
        //console.log('DEBUG - barrios_rppvap_multiples_jsonb:', barrios_rppvap_multiples_jsonb);
        //console.log('DEBUG - barrios_renabap_multiples_jsonb:', barrios_renabap_multiples_jsonb);

        updateFormData('formA', {
            datosGenerales: {
                ...restoDatos,  // Todos los campos excepto los extraídos
            },
            tipoSubtipoProyecto: Array.isArray(array_tipo_subtipo_proyecto)
                ? array_tipo_subtipo_proyecto
                : [{ tipo: '', subtipo: '', cantidad: '', unidad: '' }],
            array_obras_expediente: Array.isArray(array_obras_expediente)
                ? array_obras_expediente
                : [],
            // Campos de selección múltiple de partidos
            habilitarMultiplesPartidos: habilitar_multiples_partidos || false,
            partidosSeleccionados: partidos_multiples_jsonb || [],
            // Campos de selección múltiple de barrios RPPVAP
            barriosSeleccionados: barrios_rppvap_multiples_jsonb || [],
            // Campos de selección múltiple de tipos de barrio y barrios RENABAP
            tiposBarrioSeleccionados: tipos_barrio_jsonb || [],
            barriosRENABAPSeleccionados: barrios_renabap_multiples_jsonb || []
        });
        */

        if (estadoAppX === "inicial") { //
            cambiarEstadoApp("ediT");
        }

    }, [updateFormData, cambiarEstadoApp, resetDirtySections, loadingRef, user, arrayEditando]);

    const newRegistro = useCallback((newExpediente) => {
        setRegistro(newExpediente);
    }, []);


    const newEditInput = useCallback((editI) => {
        setEditandoInput(editI);
    }, []);

    const newModo = useCallback((newModo) => {
        setModoEdicion(newModo);
    }, []);

    // Confirmar el cambio de obra en el modal: liberar la edición de la obra actual
    // y proceder a editar la nueva obra.
    const confirmarCambioObra = () => {
        if (!edicionCambioPending) return;
        const { registro, idObraAnterior } = edicionCambioPending;
        quitarIdEdicion(idObraAnterior); // libera SOLO la edición de la obra anterior de este usuario
        confirmaCambioRef.current = true; // para que la siguiente llamada a handleEditarRegistro proceda
        setNewEditandoId(registro.id_partido_obra);
        setEdicionCambioPending(null);
        handleEditarRegistro(registro);
    };

    // Cancelar el cambio de obra: quedarse en la obra actual (restaurar su edición)
    const cancelarCambioObra = () => {
        if (!edicionCambioPending) return;
        const { idObraAnterior } = edicionCambioPending;
        if (idObraAnterior) setNewEditandoId(idObraAnterior); // restaurar la edición de la obra anterior
        setEdicionCambioPending(null);
    };

    //---> se pasa a TablaInicioContainer
    const handle_EditandoId = useCallback((newId) => {
        setNewEditandoId(newId);
    }, []);

    //handle isEditing ---> se pasa a TablaInicioContainer
    const handleIsEditing = useCallback((newIsEditing) => {
        setIsEditing(newIsEditing);
    }, []);

    const redirect = async e => {
        e.preventDefault();
        if (isSavingCont || isSavingExit) return;
        try {
            const x = "guardar_y_salir";
            setIsSavingExit(true);
            await saveExit(e, x);

        } catch (err) {
            console.error(err);
        }
    }

    const redirect_Cont = async e => {
        e.preventDefault();
        if (isSavingCont || isSavingExit) return;
        try {
            const x = "guardar_y_continuar";
            setIsSavingCont(true);
            await saveExit(e, x);

        } catch (err) {
            console.error(err);
        }
    }
    const saveExit = async (e, x) => { //registroGuardar //datos (dataSubformulario) no se usa
        //e.preventDefault();      

        try {
            // 1. Recolectar datos del formulario            

            // 2. Preparar el array de geometrías
            // Solo necesitamos 'id' y 'wkt' para enviar al backend
            const geometriesToSend = drawnFeatures.map(f => ({ //featureData
                id: f.id,
                wkt: f.wkt
                // Puedes agregar otros campos si los necesitas en el backend,
                // como un tipo de geometría si es relevante para tu modelo de datos.
                // Por ejemplo: type: f.feature.getGeometry().getType()
            }));

            //usar datos desde formB ----> tramitacioneExternas
            /*const dataToSave = tramitacionesExternas.map(item => ({
                ...item,
                fecha_salida_convenio: item.fecha_salida_convenio ? item.fecha_salida_convenio.toISOString() : null,
                fecha_firma_convenio: item.fecha_firma_convenio ? item.fecha_firma_convenio.toISOString() : null,
                fecha_salida_reso: item.fecha_salida_reso ? item.fecha_salida_reso.toISOString() : null,
                fecha_firma_reso: item.fecha_firma_reso ? item.fecha_firma_reso.toISOString() : null,
            }));*/

            // --- 2. Preparar los datos de formC_SeguimientoObra ---
            const preparePagos = (pagosArray) => {
                console.log("<----preparePagos - pagosArray---->", pagosArray);
                if (!pagosArray || !Array.isArray(pagosArray)) return [];

                return pagosArray.map(pago => {
                    const formatDate = (dateValue) => {
                        if (!dateValue) return null;
                        if (typeof dateValue === 'string' && dateValue.endsWith('Z')) {
                            return dateValue;
                        }
                        const date = new Date(dateValue);
                        if (isNaN(date.getTime())) {
                            console.warn('Fecha inválida:', dateValue);
                            return null;
                        }
                        return date.toISOString();
                    };

                    const tieneDatos = pago.monto && pago.monto !== '' && pago.monto !== '0' &&
                        pago.porc_pago && pago.porc_pago !== '';
                    const disabledCorregido = tieneDatos ? false : pago.disabled;

                    if (tieneDatos && pago.disabled === true) {
                        console.log(`preparePagos: Corrigiendo disabled para ${pago.tipo_pago}: true -> false`);
                    }

                    return {
                        ...pago,
                        disabled: disabledCorregido,
                        fecha_pago: formatDate(pago.fecha_pago),
                        fecha_certificacion: formatDate(pago.fecha_certificacion)
                    };
                });
            };
            const preparedPagosMejoras = (() => {
                const pagos = preparePagos(arrayPagosMejoras);
                if (datosGenerales?.area_responsable !== 'ÁREA DE MEJORAS') return pagos;
                const adendasValidas = (array_obras_expediente || []).filter(exp => exp && exp.objeto_o === 'Adenda' && parseFloat(exp.monto_adenda) > 0);
                let adendaCount = 0;
                return pagos.filter(p => {
                    if (p.tipo_pago !== 'adenda') return true;
                    adendaCount++;
                    return adendaCount <= adendasValidas.length;
                });
            })();
            const preparedPagosMicrocreditos = preparePagos(arrayPagosMicrocreditos);
            const preparedPagosProyectos = preparePagos(arrayPagosProyectos);
            const preparedPagosIntervencionSocial = preparePagos(arrayPagosIntervencionSocial);
            const preparedPagosCapacitaciones = preparePagos(arrayPagosCapacitaciones);

            // Validación de consistencia: si estadoApp indica edición, id_partido_obra debe existir
            const esEstadoEdit = estadoAppX && (estadoAppX === 'ediT' || estadoAppX.startsWith('edit_'));
            if (esEstadoEdit) {
                console.log('[DEBUG saveExit] datosGenerales:', JSON.stringify(datosGenerales, null, 2));
            }
            if (esEstadoEdit && !datosGenerales?.id_partido_obra) {
                console.warn(`[RECUPERACIÓN] estadoAppX='${estadoAppX}' pero id_partido_obra no está. Intentando recuperar con id=${datosGenerales?.id}...`);
                let idPartidoObraRecuperado = null;
                if (datosGenerales?.id) {
                    try {
                        const registroRecuperado = await getRegistroById(datosGenerales.id);
                        idPartidoObraRecuperado = registroRecuperado?.id_partido_obra || null;
                        if (idPartidoObraRecuperado) {
                            console.log(`[RECUPERACIÓN] id_partido_obra recuperado: ${idPartidoObraRecuperado}`);
                        }
                    } catch (e) {
                        console.error('[RECUPERACIÓN] Error:', e);
                    }
                }
                if (!idPartidoObraRecuperado) {
                    console.error(`[INCONSISTENCIA] No se pudo recuperar id_partido_obra. Se cancela.`);
                    toast.error('Error: no se puede identificar la obra a editar. Recargue la página.');
                    setIsSavingExit(false);
                    setIsSavingCont(false);
                    return;
                }
                // Inyectar el id_partido_obra recuperado en datosGenerales para el requestBody
                datosGenerales.id_partido_obra = idPartidoObraRecuperado;
            }

            // Validación: si el expediente ya existe en BD, bloquear el guardado
            if (datosGenerales?.expediente_duplicado) {
                console.error('[BLOQUEO] El expediente ya existe en la base de datos. Se cancela el guardado.');
                toast.error('El expediente ya existe en la base de datos. Corrija el expediente antes de guardar.');
                setIsSavingExit(false);
                setIsSavingCont(false);
                return;
            }

            // Validación: si hay un expediente incompleto o con formato inválido, bloquear el guardado
            if (datosGenerales?.expediente_incompleto) {
                console.error('[BLOQUEO] Hay un expediente incompleto o con formato inválido. Complete los campos antes de guardar.');
                toast.error('Complete el número de expediente (o corrijale el formato) antes de guardar.');
                setIsSavingExit(false);
                setIsSavingCont(false);
                return;
            }

            // Determinar si es edición
            const esEdicion = estadoAppX === 'ediT' || estadoAppX?.startsWith('edit_');

            // 3. Construir el objeto body de la solicitud
            const requestBody = {
                user: user,
                estadoApp: estadoAppX, //hacer cambio en SERVER
                dirtySections: esEdicion ? { ...dirtySections } : {
                    formA: true,
                    formB_main: true,
                    formB_observaciones: true,
                    formB_expedienteProyecto: true,
                    formC_main: true,
                    formC_pagos: true,
                    formC_mediciones: true,
                    formC_mejoras: true,
                    formC_geometries: true,
                    formC_beneficiarios: true,
                    formC_circuitoAdmin: true
                }
            };

            // registro/id_partido_obra siempre se envía para identificación en el backend
            // (independientemente de dirtySections.formA, porque el backend lo necesita
            //  para leer cg_01_id_partido_obra incluso en el else de PASO 2)
            requestBody.registro = datosGenerales;

            // Incluir datos solo de secciones sucias (o todas si es nueva obra)
            if (!esEdicion || dirtySections.formA) {
                requestBody.dataSubformulario = tipoSubtipoProyecto;
                requestBody.dataSubformularioExpediente = (Array.isArray(array_obras_expediente) ? array_obras_expediente : []).filter(exp => exp && typeof exp === 'object');
                requestBody.habilitarMultiplesPartidos = habilitarMultiplesPartidos;
                requestBody.partidosSeleccionados = partidosSeleccionados;
                requestBody.barriosSeleccionados = barriosSeleccionados;
                requestBody.tiposBarrioSeleccionados = tiposBarrioSeleccionados;
                requestBody.barriosRENABAPSeleccionados = barriosRENABAPSeleccionados;
                requestBody.barrioOtroNombres = barrioOtroNombres;
                requestBody.etapa = datosGenerales.etapa || null;
                requestBody.id_etapa1_referencia = datosGenerales.id_etapa1_referencia || null;
                requestBody.tipo_microcredito = datosGenerales.tipo_microcredito || null;
            }

            if (!esEdicion || dirtySections.formB_main || dirtySections.formB_observaciones || dirtySections.formB_tramitacionExterna) {
                requestBody.selectedRequisitos = selectedRequisitos;
                requestBody.tramitacionesInternas = tramitacion;
                requestBody.observacionesReporteEntidad = reporteEntidad;
                requestBody.observacionesInternas = internas;
                requestBody.observacionesTramitacionExterna = tramitacionExterna;
                requestBody.dataToSave = tramitacionesExternas;
            }

            if (!esEdicion || dirtySections.formB_observaciones) {
                requestBody.observacionesInternasArray = formB?.internasHistorico || [];
            }

            if (!esEdicion || dirtySections.formB_expedienteProyecto) {
                requestBody.expedienteProyecto = formB?.expedienteProyecto || [];
            }

            if (!esEdicion || dirtySections.formC_main) {
                requestBody.encargado_seguimiento = encargadoSeguimiento;
                requestBody.monto_obraC = montoObra;
                requestBody.fecha_inicio_obra = fechaInicioObra;
                requestBody.fecha_fin_obra = fechaFinObra;
                requestBody.observ_seguimiento_obra = observacionesSeguimientoObra;
            }

            if (!esEdicion || dirtySections.formC_circuitoAdmin) {
                requestBody.arrayCircuitoAdmin = formC?.arrayCircuitoAdmin || [];
            }

            if (!esEdicion || dirtySections.formC_mejoras) {
                requestBody.arrayMejorasEtapaI = formC?.arrayMejorasEtapaI || [];
                requestBody.arrayMejorasEtapaII = formC?.arrayMejorasEtapaII || [];
            }

            if (!esEdicion || dirtySections.formC_pagos) {
                requestBody.arrayPagosMejoras = preparedPagosMejoras;
                requestBody.arrayPagosMicrocreditos = preparedPagosMicrocreditos;
                requestBody.arrayPagosProyectos = preparedPagosProyectos;
                requestBody.arrayPagosIntervencionSocial = preparedPagosIntervencionSocial;
                requestBody.arrayPagosCapacitaciones = preparedPagosCapacitaciones;
                requestBody.porcentaje_parcial_2do_pago = formC?.porcentaje_parcial_2do_pago || null;
                requestBody.porcentaje_parcial_3er_pago = formC?.porcentaje_parcial_3er_pago || null;
            }

            if (!esEdicion || dirtySections.formC_mediciones) {
                requestBody.arrayMediciones = formC?.arrayMediciones || [];
            }

            if (!esEdicion || dirtySections.formC_geometries) {
                requestBody.geometries = geometriesToSend;
            }

            if (!esEdicion || dirtySections.formC_beneficiarios) {
                requestBody.beneficiarios = Array.isArray(formA?.arrayBeneficiarios) ? formA.arrayBeneficiarios : [];
            }

            console.log('Objeto body de la solicitud:', requestBody);

            // =========================================================================
            // VALIDACIÓN FRONTEND: Mediciones sin fecha (advertencia, no bloquea).
            // Para role=seguimiento se omite: la fecha no es obligatoria para ese rol.
            // =========================================================================
            const medicionesSinFecha = (formC?.arrayMediciones || []).filter(m => !m.fecha_medicion);
            if (medicionesSinFecha.length > 0 && role !== 'seguimiento') {
                const nrosMediciones = medicionesSinFecha.map(m => `N° ${m.nro_medicion}`).join(', ');
                toast.warn(
                    `⚠️ Las mediciones ${nrosMediciones} se guardarán sin fecha. Recordá completarlas luego.`,
                    { autoClose: 6000 }
                );
                // TODO 04-jun-2026: Descomentar este return cuando se quiera activar la restricción estricta de fecha obligatoria
                // return;
            }

            if (x === "guardar_y_salir") {
                console.log("OSO llega?")
                setModalAccion("guardar_y_salir")

                const response = await fetch(
                    `/api/nuevaObra`,
                    {
                        method: "POST",
                        headers: {
                            "Content-type": "application/json",
                            'X-Socket-Id': socketRef.current?.id || socket?.id || '',
                            ...(token ? { 'Authorization': `Bearer ${token}` } : {})
                        },
                        body: JSON.stringify(requestBody)
                    }
                );

                // Manejo específico de sesión expirada
                if (response.status === 401 || response.status === 403) {
                    toast.error('Sesión expirada. Por favor, inicia sesión nuevamente.');
                    window.location.assign('/login');
                    setModalAccion(null)
                    return;
                }

                const respuesta_json = await response.json();
                console.log("RESPUESTA DESPUES DEL CAMBIO", respuesta_json)

                const mensaje = respuesta_json.message;
                const dataResponse = respuesta_json.data;


                if (!respuesta_json.success) {
                    console.log('1');
                    toast.error(mensaje);
                    setModalAccion(null)
                } else {


                    if (dataResponse.version === 1) { //primer version ---> es nuevo
                        //setData(prevData => [respuesta_json, ...prevData ]);
                        //setData(prev => [...prev, dataResponse]);

                        //actualizar tabla de inicio llamando a getObras() 
                        await getObras() //solo trae los datos basico s para la tabla de inicio

                        //Actualiza el array data para incluir el nuevo registro
                        //setData(prev => [...prev, dataResponse]);
                        clearFeatures(); //borra las features del mapa
                        toast("¡Operación exitosa!, nuevo registro creado")
                    } else if (dataResponse.version > 1) { // es una actualizacion
                        console.log("2 - Actualizando")
                        //quitarIdEdicion(registro.id_partido_obra);
                        quitarIdEdicion(datosGenerales.id_partido_obra)
                        await getObras() //actualiza solo la tabla de inicio
                        /*setData(prevData => {
                            const newData = prevData.map(item => {
                                if (item.id_origen === respuesta_json.id_origen) {
                                    return respuesta_json; // **REEMPLAZA el objeto antiguo con el nuevo objeto actualizado**
                                } else {
                                    return item;      // Deja los demás objetos sin cambios
                                }
                            });
                            return newData; // Devuelve el *nuevo* array con el objeto actualizado
                        });*/
                        toast("¡Operación exitosa!, registro editado")
                    }


                    //setEstadoApp("inicial") // Vuelve al estado inicial al guardar y salir


                    if (estadoAppX === "edit_desde_pagos" || estadoAppX === "edit_desde_proyectos") {

                        if (origenNavegacion === "analisis_pagos") {
                            // Volver a Análisis de Pagos (origen propio, no forzar tramitaciones)
                            console.log('Navegando a /analisis-pagos tras guardar');
                            navigate(`/analisis-pagos?edicionExitosa=true`, { replace: true });
                        } else if (origenNavegacion === "obras_sin_pagos") {
                            // Volver a Obras sin pagos (origen propio)
                            console.log('Navegando a /obras-sin-pagos tras guardar');
                            navigate(`/obras-sin-pagos?edicionExitosa=true`, { replace: true });
                        } else if (origenNavegacion === "inicio") {
                            // Post-cambio de partido: se edita el proyecto migrado; al guardar y salir volver a /inicio
                            console.log('Navegando a /inicio tras guardar (cambio de partido)');
                            navigate(`/inicio`, { replace: true });
                        } else if (origenNavegacion === "contactos_ong") {
                            // Edición lanzada desde la lista de obras de una ONG: volver a esa ONG
                            volverAContactosONG(navigate, true);
                        } else {
                            //if (origenNavegacion === "tramitaciones") {
                            const tabOrigen = localStorage.getItem('lastActiveTab'); //location.state?.origen; // 'pagos' o 'proyectos'
                            console.log('Navegando a /tramitaciones con tab:', tabOrigen);
                            if (tabOrigen) { // Solo si hay un origen específico
                                console.log("TIENE tabOrigen")
                                navigate(`/tramitaciones?edicionExitosa=true`, {
                                    //state: {
                                    //    tabActivo: tabOrigen
                                    //},----> usar origen desde locastorage: lastActiveTab
                                    replace: true // Para no guardar en el historial
                                });
                            } else {
                                console.log("NO TIENE tabOrigen")
                                // Si no hay origen específico, navegar sin forzar el tab
                                navigate(`/inicio`, { replace: true });
                            }
                            //}
                        }
                        clearFeatures(); //borra las features del mapa
                        setBloquear(false);
                        toast("¡Operación exitosa!, registro editado")
                    }

                    //limpiar de localStorage id_partido_obra
                    localStorage.removeItem('idPartidoObra');
                    cambiarEstadoApp("inicial");

                    //setGuardarEstados(false); // ------>                   
                    resetDirtySections();

                    setTimeout(() => setModalAccion(null), 2000);
                }


            } else if (x === "guardar_y_continuar") {

                setModalAccion("guardar_y_continuar")

                console.log("primero fue nuevo, segunda vuelta es edit")

                const response = await fetch(
                    `/api/nuevaObra`,
                    {
                        method: "POST",
                        headers: {
                            "Content-type": "application/json",
                            'X-Socket-Id': socketRef.current?.id || socket?.id || '',
                            ...(token ? { 'Authorization': `Bearer ${token}` } : {})
                        },
                        body: JSON.stringify(requestBody)
                    }
                );

                // Manejo específico de sesión expirada
                if (response.status === 401 || response.status === 403) {
                    toast.error('Sesión expirada. Por favor, inicia sesión nuevamente.');
                    window.location.assign('/login');
                    setModalAccion(null)
                    return;
                }

                const parseRes = await response.json();
                //console.log("parseRes en guardar y continuar", parseRes)

                const mensaje = parseRes.message; //usar esta linea
                const dataResponse = parseRes.data; //usar esta linea
                const version = dataResponse.version; //usar esta linea
                //lo obtinene de dataResponse para luego usarlo si es necesario
                const id_obraResponse = dataResponse.id; // no viene id_obra, usamos el id de la respuesta para actaulizar el contexto
                const id_partido_obraResponse = dataResponse.cg_01_id_partido_obra; // no olvidar pasar version desde backend con parseRes.



                //if (parseRes.id === undefined) {
                //alert(`Ocurrió un error al guardar el registro. En caso de persisitir comunicarse con un administrador.`);
                //} else if (parseRes.id !== undefined ){//&& parseRes.id !== parseRes.id_origen --> son distintos porque id es el incremental y id_origen es donde comenzo la obra
                if (!parseRes.success) {
                    console.log('1');
                    toast.error(mensaje);
                    setModalAccion(null)

                } else if (parseRes.success && version === 1) {
                    console.log("DEBUG IF: primer if")
                    //updateField('formA', 'datosGenerales', 'id_obra', id_obraResponse);
                    updateField('formA', 'datosGenerales', 'id_origen', id_obraResponse); //parseRes.id_origen
                    updateField('formA', 'datosGenerales', 'id_partido_obra', id_partido_obraResponse); // antes era parseRes.id_partido_obra
                    updateField('formA', 'datosGenerales', 'fecha_actualizacion', parseRes.fecha_actualizacion);

                    toast("¡Operación exitosa!, registro nuevo - CONT 1")
                    //setEstadoApp("ediT"); // Cambia al estadoApp 'ediT' al guardar y continuar después de crear
                    cambiarEstadoApp("ediT");
                    setNewEditandoId(id_partido_obraResponse); //parseRes.id_partido_obra
                    setBeneficiariosReloadKey(prev => prev + 1);

                    // PENSAR ESTRATEGIA : para mostrar el nuevo registro necesito obtener los datos del nuevo registro del backend. 
                    // la forma es hacer un fetch a la api con el id_partido_obra y los datos del nuevo registro se obtienen de la respuesta.
                    // por ahora lo dejamos asi para no complicar mas el tema
                    //setData((prevData) => [parseRes, ...prevData]);
                } else if (parseRes.success && version === 1 && estadoAppX === 'nuevo_etapa2') {
                    console.log("DEBUG IF: segundo if")
                    //es la primera vez que se guarda etapa 2, pero ya existe etapa 1
                    //en este caso no se debe cambiar a estado 'ediT'

                    setNewEditandoId(id_partido_obraResponse);

                    //setEstadoApp("ediT");
                    setNewEditandoId(id_partido_obraResponse); //parseRes.id_partido_obra 
                    cambiarEstadoApp("edit_etapa2");
                    toast("¡Operación exitosa!, registro editado - CONT 2")
                    setBeneficiariosReloadKey(prev => prev + 1);

                } else if (parseRes.success && version > 1 && estadoAppX === 'ediT') { //si es version > 1 es que es una actualizacion
                    console.log("DEBUG IF: tercer if")
                    // Guardar Etapa II - cambiar a estado edición de Etapa II
                    updateField('formA', 'datosGenerales', 'id_origen', id_obraResponse);
                    updateField('formA', 'datosGenerales', 'id_partido_obra', id_partido_obraResponse);
                    updateField('formA', 'datosGenerales', 'fecha_actualizacion', parseRes.fecha_actualizacion);

                    toast("¡Operación exitosa!, registro editado - CONT 3")
                    //cambiarEstadoApp("edit_etapa2");
                    setNewEditandoId(id_partido_obraResponse);
                    setBeneficiariosReloadKey(prev => prev + 1);

                } else if (parseRes.success && version > 1 && estadoAppX === 'edit_etapa2') { //si es version > 1 y estadoAppX === 'ediT' o 'edit_etapa2' es que es una actualizacion
                    console.log("DEBUG IF: cuarto if")
                    updateField('formA', 'datosGenerales', 'id_origen', id_obraResponse);
                    updateField('formA', 'datosGenerales', 'id_partido_obra', id_partido_obraResponse);
                    updateField('formA', 'datosGenerales', 'fecha_actualizacion', parseRes.fecha_actualizacion);
                    toast("¡Operación exitosa!, Etapa II creada - CONT")
                    setBeneficiariosReloadKey(prev => prev + 1);

                    setData(prevData => {
                        const newData = prevData.map(item => {
                            if (item.id_origen === parseRes.id_origen) {
                                return parseRes; // **REEMPLAZA el objeto antiguo con el nuevo objeto actualizado**
                            } else {
                                return item;      // Deja los demás objetos sin cambios
                            }
                        });
                        return newData; // Devuelve el *nuevo* array con el objeto actualizado
                    });
                    //mantenemos esta ediT o edit_etapa2

                }

                if (parseRes.success) {
                    resetDirtySections();
                    setTimeout(() => setModalAccion(null), 2000);
                }

            }

        } catch (err) {
            console.error(err);
            setModalAccion(null);
        } finally {
            // Restablecer estados de carga según la acción
            if (x === "guardar_y_salir") {
                setIsSavingExit(false);
            } else if (x === "guardar_y_continuar") {
                setIsSavingCont(false);
            }
        }
    }



    // *****INICIA UseEffect********************
    useEffect(() => {
        console.log("AUX ejecutando")
        setMontoObraC(datosGenerales.monto_obra)
    }, [datosGenerales?.monto_obra])


    useEffect(() => {
        consultar_array_editando(); //ahora para todos los usuarios

    }, [])

    //un useEffcet para detecatar cambios en escuchandoLocalData
    useEffect(() => {
        console.log("escuchandoLocalData", escuchandoLocalData)
        //modificar registro de manera funcional con el valor en escuchandoLocalData
        setRegistro(prevRegistro => ({
            ...prevRegistro,
            nombre_obra: escuchandoLocalData.nombre_obra
        }));
    }, [escuchandoLocalData])

    // useEffect para inicializar tramitacionesExternas basado en array_obras_expediente
    /*useEffect(() => {
        if (registro?.array_obras_expediente && registro?.array_obras_expediente.length > 0) {
            const initialTramitaciones = registro?.array_obras_expediente.map((obraExp, idx) => ({
                id: `exp-${obraExp.expediente_o}-${idx}`, // Generar un ID único basado en el expediente y un índice
                exp: obraExp.expediente_o, // Asignar el valor del expediente_o
                fecha_salida_convenio: null,
                fecha_firma_convenio: null,
                fecha_salida_reso: null,
                fecha_firma_reso: null,
            }));
            setTramitacionesExternas(initialTramitaciones);
        } else {
            // Si no hay expedientes, asegurarnos de que el estado esté vacío o con un valor por defecto si lo prefieres
            setTramitacionesExternas([]);
        }
    }, [registro?.array_obras_expediente]);*/ // ¡Importante! Este useEffect se ejecutará cuando array_obras_expediente cambie

    /* //31-JUL-25
    useEffect(() => {
        setTramitacionesExternas(prevTramitaciones => {
            const newTramitaciones = [];
            const existingTramitacionesMap = new Map(
                prevTramitaciones.map(t => [t.exp, t]) // Mapea las tramitaciones existentes por su 'exp'
            );

            registro?.array_obras_expediente.forEach((obraExp, idx) => {
                const expediente_o = obraExp.expediente_o;
                const existingTramitacion = existingTramitacionesMap.get(expediente_o);

                if (existingTramitacion) {
                    console.log("YA EXISTE UNA TRAMITACION PARA ESTE EXPEDIENTE", existingTramitacion)
                    // Si ya existe una tramitación para este expediente_o, la reutilizamos
                    // y nos aseguramos de que el ID esté actualizado si el orden cambió
                    newTramitaciones.push({
                        ...existingTramitacion,
                        id: `exp-${expediente_o}-${idx}`, // Actualizamos el ID por si el índice cambió
                        exp: expediente_o // Aseguramos que 'exp' sea el correcto
                    });
                } else {
                    // Si no existe, creamos una nueva tramitación con valores por defecto
                    newTramitaciones.push({
                        id: `exp-${expediente_o}-${idx}`,
                        exp: expediente_o,
                        fecha_salida_convenio: null,
                        fecha_firma_convenio: null,
                        fecha_salida_reso: null,
                        fecha_firma_reso: null,
                    });
                }
            });
            return newTramitaciones;
        });
    }, [registro?.array_obras_expediente]); // Se ejecuta cuando array_obras_expediente cambia    

    //si se encontaron datos del form_b (busqueda por id)    
    useEffect(()=>{
        if(formularioConsultado){
            console.log("mostrar que tiene formularioConsultado", formularioConsultado)
            const documentos = formularioConsultado.documentos_seleccionados;
            const observaciones_reporte = formularioConsultado.observaciones_reporte;
            const observaciones_internas = formularioConsultado.observaciones_internas;
            const tramitacionesInternas = formularioConsultado.tramitacion_interna_jsonb;
            const tramitacionesExternas = formularioConsultado.tramitacion_externa_jsonb;

            //setSelectedItems(documentos) //NOTA: Estaba comentado (por qué??) 27-jul-2025
            setSelectedRequisitos(documentos) //NOTA ES ESTE EL QUE HAY QUE USARsaveExit
            setObservacionesReporteEntidad(observaciones_reporte)
            setObservacionesInternas(observaciones_internas)
            setTramitacionesInternas(tramitacionesInternas)
            console.log("ENTRA ACA?")
            setTramitacionesExternas(tramitacionesExternas)
        }

    }, [formularioConsultado])*/

    // Segundo useEffect: Procesa los datos de formularioConsultado una vez que se carga
    //VERFIFICAR  5dic25 ----> formulario consultado

    useEffect(() => {

        const tramitacionInternaTemp = {
            registracion_ong: "",
            resolucion_ong: "",
            documentacion_ong: "",
            informe_tecnico: "", //nuevo requisito 22-jul-2025
            modelo_convenio: "",
            proyecto_resolucion: "",
            resolucion: "",
            programa: ""
        };
        if (formularioConsultado) {
            console.log("Procesando formularioConsultado:", formularioConsultado);

            // Actualiza los estados de otros datos del formulario
            //setSelectedRequisitos(formularioConsultado.documentos_seleccionados || []); //comentar por ahora hasta verficar formulario consultado
            setObservacionesReporteEntidad(formularioConsultado.observaciones_reporte || '');
            setObservacionesInternas(formularioConsultado.observaciones_internas || '');
            setTramitacionesInternas(formularioConsultado.tramitacion_interna_jsonb || tramitacionInternaTemp); // || null

            // --- Lógica Clave para tramitacionesExternas ---
            //ya no es registro.array_obras_expediente ahora directamente desde el context (array_obras_expediente)
            const loadedArrayObrasExpediente = array_obras_expediente || []; //formularioConsultado.array_obras_expediente || [];
            const loadedTramitacionesExternasBD = formularioConsultado.tramitacion_externa_jsonb || [];

            // Convertir las tramitaciones externas cargadas a un mapa para búsqueda rápida
            const tramitacionesBDMap = new Map(
                loadedTramitacionesExternasBD.map(t_bd => [
                    t_bd.exp, // La clave es el nombre del expediente
                    {
                        ...t_bd,
                        // ¡IMPORTANTE! Convertir strings ISO de vuelta a objetos Date
                        fecha_salida_convenio: t_bd.fecha_salida_convenio ? new Date(t_bd.fecha_salida_convenio) : null,
                        fecha_firma_convenio: t_bd.fecha_firma_convenio ? new Date(t_bd.fecha_firma_convenio) : null,
                        fecha_salida_reso: t_bd.fecha_salida_reso ? new Date(t_bd.fecha_salida_reso) : null,
                        fecha_firma_reso: t_bd.fecha_firma_reso ? new Date(t_bd.fecha_firma_reso) : null,
                    }
                ])
            );

            // Construir el array final de tramitacionesExternas para el estado del formulario
            const finalTramitacionesExternas = loadedArrayObrasExpediente.map((obraExp, idx) => {
                const expediente_o = obraExp.expediente_o;
                const existingTramitacion = tramitacionesBDMap.get(expediente_o);

                if (existingTramitacion) {
                    // Si existe en los datos cargados de la BD, usamos esos datos
                    return {
                        ...existingTramitacion,
                        id: `exp-${expediente_o}-${idx}`, // Aseguramos el ID correcto para React keys
                        exp: expediente_o // Confirmamos el nombre del expediente
                    };
                } else {
                    // Si es un expediente nuevo (no vino en la BD), lo inicializamos
                    return {
                        id: `exp-${expediente_o}-${idx}`,
                        exp: expediente_o,
                        fecha_salida_convenio: null,
                        fecha_firma_convenio: null,
                        fecha_salida_reso: null,
                        fecha_firma_reso: null,
                    };
                }
            });

            // Actualizar los estados finales
            //setTramitacionesExternas(finalTramitacionesExternas); //comentar por ahora hasta verficar formulario consultado
        }
    }, [formularioConsultado]); // Este useEffect se ejecuta solo cuando formularioConsultado cambia


// Sincronizar tramitacionesExternas cuando array_obras_expediente cambia durante la edición
    // (ej. el usuario agrega o elimina un expediente en formA → formB.tramitacionesExterna).
    // Se reconcilia 1:1 con exp|objeto: se conservan las filas existentes (fechas de BD),
    // se descarran las que ya no tienen expediente y se agregan las nuevas.
    useEffect(() => {
        if (array_obras_expediente.length === 0) return;

        const prevTramitaciones = formB?.tramitacionesExternas || [];
        const prevByKey = new Map(
            prevTramitaciones
                .filter(t => t && t.exp)
                .map(t => [t.exp && t.objeto ? `${t.exp}|${t.objeto}` : t.exp, t])
        );

        const newTramitaciones = array_obras_expediente
            .filter(obraExp => obraExp && obraExp.expediente_o)
            .map((obraExp, idx) => {
                const key = obraExp.expediente_o && obraExp.objeto_o
                    ? `${obraExp.expediente_o}|${obraExp.objeto_o}`
                    : obraExp.expediente_o;
                const existing = prevByKey.get(key);
                if (existing) {
                    // Se conserva el id que ya tiene la fila: regenerarlo cambia la key de
                    // React, remonta el input y descarta lo que el usuario estaba tipeando.
                    return { ...existing, id: existing.id || `expte-${obraExp.expediente_o}-${idx}`, objeto: obraExp.objeto_o };
                }
                return {
                    id: `expte-${obraExp.expediente_o}-${idx}`,
                    exp: obraExp.expediente_o,
                    objeto: obraExp.objeto_o,
                    fecha_salida_convenio: null,
                    fecha_firma_convenio: null,
                    fecha_salida_reso: null,
                    fecha_firma_reso: null,
                };
            });

        const sameCount = prevTramitaciones.length === newTramitaciones.length;
        if (sameCount) {
            const prevKeys = new Set(prevByKey.keys());
            const newKeys = new Set(
                newTramitaciones.map(t => t.exp && t.objeto ? `${t.exp}|${t.objeto}` : t.exp)
            );
            const keysIguales = prevKeys.size === newKeys.size &&
                [...prevKeys].every(k => newKeys.has(k));
            if (keysIguales) return;
        }

        if (!loadingRef.current) {
            updateTramitaciones('externas', newTramitaciones);
        } else {
            loadFormB({ tramitacionesExternas: newTramitaciones });
        }
    }, [array_obras_expediente]);

    //useEffect al recibir cambios en formularioSeguimientoObra
    useEffect(() => {
        if (formularioSeguimientoObra) {
            console.log("FormularioSeguimientoObra actualizado:", formularioSeguimientoObra);

            // Actualizar los estados individuales con los datos del formulario
            //actulizar encargado de seguuimiento
            if (formularioSeguimientoObra.encargado_seguimiento) {
                setEncargadoSeguimiento(formularioSeguimientoObra.encargado_seguimiento);
            }

            /* ESTAS 3 se van, ya no es encargado de renciion es encargado de seguimiento. Organismo encargado y empres contratista se van.
            if (formularioSeguimientoObra.encargado_rendicion) {
                setEncargadoRendicion(formularioSeguimientoObra.encargado_rendicion);
            }
            if (formularioSeguimientoObra.organismo_encargado) {
                setOrganismoEncargado(formularioSeguimientoObra.organismo_encargado);
            }
            if (formularioSeguimientoObra.empresa_contratista) {
                setEmpresaContratista(formularioSeguimientoObra.empresa_contratista);
            }
            */
            if (formularioSeguimientoObra.monto_obraC) {
                setMontoObraC(formularioSeguimientoObra.monto_obraC);
            }
            if (formularioSeguimientoObra.observ_seguimiento_obra) {
                setObservSeguimientoObra(formularioSeguimientoObra.observ_seguimiento_obra);
            }
            //fecha_inicio_obra y fecha_fin_obra
            if (formularioSeguimientoObra.fecha_inicio_obra) {
                setFechaInicioObra(formularioSeguimientoObra.fecha_inicio_obra);
            }
            if (formularioSeguimientoObra.fecha_fin_obra) {
                setFechaFinObra(formularioSeguimientoObra.fecha_fin_obra);
            }
        }
    }, [formularioSeguimientoObra])


    //NOTA: si cambia id editando ---> llamar function getFormB_Tramitacion y getFormC_SeguimientoObra
    // Espejo del id actual en un ref: los fetches de formB/formC lo usan para descartar
    // respuestas stale (evita que la obra anterior "pise" a la nueva al resolver tarde).
    useEffect(() => {
        newEditandoIdRef.current = new_EditandoId;
    }, [new_EditandoId]);

    useEffect(() => {
        if (new_EditandoId) {
            // Resetear formB y formC a valores iniciales ANTES de fetch la nueva obra,
            // para que no queden datos de la obra anterior mientras carga (evita "caché").
            loadFormB({
                selectedRequisitos: {},
                tramitacion: {},
                tramitacionesExternas: [],
                observaciones: {
                    reporteEntidad: '',
                    internas: '',
                    tramitacionExterna: ''
                },
                internasHistorico: [],
                expedienteProyecto: [],
                orgDocsExpanded: false
            });
            loadFormC({
                seguimientoObra: {
                    encargadoSeguimiento: '',
                    montoObra: '',
                    fechaInicioObra: '',
                    fechaFinObra: '',
                    observaciones: ''
                },
                arrayPagosMejoras: [...PAGO_MEJORAS_INICIAL],
                arrayPagosMicrocreditos: [...PAGO_MICROCREDITOS_INICIAL],
                arrayPagosProyectos: [...PAGO_PROYECTOS_INICIAL],
                arrayPagosIntervencionSocial: [...PAGO_INTERVENCIÓN_SOCIAL_INICIAL],
                arrayPagosCapacitaciones: [...PAGO_CAPACITACIONES_INICIAL],
                porcentaje_parcial_2do_pago: null,
                porcentaje_parcial_3er_pago: null,
                arrayMediciones: [],
                arrayMejorasEtapaI: [],
                arrayMejorasEtapaII: [],
                arrayCircuitoAdmin: []
            });

            Promise.all([
                getFormB_Tramitacion(),
                getFormC_SeguimientoObra()
            ]).then(() => {
                // loadingRef se resetea con setTimeout para que React primero procese
                // los renders y efectos hijos (auto-correcciones de disabled, porcentajes)
                // con loadingRef = true, evitando que marquen dirty prematuramente.
                setTimeout(() => loadingComplete?.(), 0);
            });
        }

    }, [new_EditandoId, loadingComplete])

    //si cambia id editando ---> llamar function getGeometriesByObraId -9jul25-
    useEffect(() => {
        if (new_EditandoId) {
            //console.log("ahora tiene valor, pegar a endpoint")
            loadFeaturesForObra(new_EditandoId)
        }
    }, [new_EditandoId])

    //Cargar beneficiarios (usando loadField para no marcar dirtySections durante carga inicial)
    useEffect(() => {
        if (new_EditandoId) {
            fetch(`/api/obras/${new_EditandoId}/beneficiarios`, {
                headers: { ...(token ? { 'Authorization': `Bearer ${token}` } : {}) }
            })
                .then(res => res.json())
                .then(data => {
                    loadField('formA', 'arrayBeneficiarios', null, data || []);
                })
                .catch(err => console.error('Error al cargar beneficiarios:', err));
        }
    }, [new_EditandoId, beneficiariosReloadKey])


    useEffect(() => {
        console.log("manejar todos los cambios de new_ EMIT--->", new_EditandoId)
        if (socket && socket.id && isSocketConnected) {
            //if new_EditandId tiene valor, emitirlo. No puede ser vacio ""
            // Mientras haya un modal de cambio de obra pendiente, no emitir (evita liberar
            // la edición de la obra anterior antes de que el usuario confirme el cambio).
            if (new_EditandoId && !edicionCambioPending) {
                socket.emit("editando_id", new_EditandoId) // por ahora COMENTAR #27FEB25
            }
        }
    }, [new_EditandoId, socket, isSocketConnected, edicionCambioPending]) //new_EditandoId, socket, isSocketConnected


    /*
    NOTA: para determinar "EDICION INICIADA POR ---->", usuarioInicial //POR AHORA COMENTAR 17-oct-2025
    useEffect(()=>{
        const safeArray = Array.isArray(arrayEditando) ? arrayEditando : [];
        const busqueda = safeArray.filter((editando)=>{return editando.id_edit === new_EditandoId})

        if(busqueda.length > 0){
            console.log("YA SE ESTA EDITANDO", busqueda)
            setBusquedaUsuarios(busqueda)
        }

    },[new_EditandoId])


    useEffect(()=>{
        if(busquedaUsuarios.length > 0){
            const usuarioInicial = busquedaUsuarios[0]["user_edit"]
            console.log("EDICION INICIADA POR ---->", usuarioInicial)
            setBloquear(true)
        }

    }, [busquedaUsuarios])
    */

    // Mantener ref actualizada con los valores más recientes para el socket handler
    promotionRef.current = { new_EditandoId, recordId, user, handleEditarRegistro, getFormC_SeguimientoObra, setIsEditing, token, updateFormData };

    // Socket listeners: array_editando (simple) + promovido_a_editor (dedicated promotion handling)
    useEffect(() => {
        if (socket) {
            console.log("ESTÄ ESCUCHANDO??")
            const procesarArray = (data) => {
                console.log("ESCUCHAR CAMBIOS aca´ --->", data)
                setArrayEditando(data)
            }
            socket.on("array_editando", procesarArray)

            // Evento dedicado: server emite SOLO al usuario que fue promovido de solo_lectura a editando
            socket.on('promovido_a_editor', (idPartidoObra) => {
                const ref = promotionRef.current;
                console.log('[promovido_a_editor] Recibido:', idPartidoObra, 'new_EditandoId:', ref.new_EditandoId);
                if (idPartidoObra !== ref.new_EditandoId) return;
                // Mostrar modal React en lugar de window.confirm (Chrome suprime confirm() en eventos asíncronos sin DevTools)
                setPendingPromocion(idPartidoObra);
            });

            return () => {
                socket.off("array_editando", procesarArray)
                socket.off("promovido_a_editor")
            }
        }
    }, [socket])

    // Recalcular isEditing y trigger modal de solo_lectura (mismo effect para evitar render intermedio)
    useEffect(() => {
        if (!new_EditandoId || !user) {
            return;
        }
        const userClean = user.replace(/"/g, '');
        const safeArray = Array.isArray(arrayEditando) ? arrayEditando : [];
        const myEntry = safeArray.find(item =>
            item.id_edit === new_EditandoId &&
            item.user_edit?.replace(/"/g, '') === userClean
        );
        const isSoloLectura = myEntry?.status === 'solo_lectura';
        setIsEditing(isSoloLectura);
        // Mostrar modal una vez por registro al entrar en modo lectura (si no hay promoción en curso)
        if (isSoloLectura && soloLecturaShownRef.current !== new_EditandoId && !pendingPromocion) {
            soloLecturaShownRef.current = new_EditandoId;
            setShowSoloLecturaModal(true);
        }
    }, [arrayEditando, new_EditandoId, user, pendingPromocion])


    /*useEffect(() =>{

        if(estadoAppX === "inicial" && nueva_obra === true){
            //alert("Nueva Obra, Refrescar pagina")
        }

    }, [nueva_obra])*/

    useEffect(() => { //ver OPCION 1
        //console.log("QUE TIENE REGUSTRO EN EL CLIENTE", registro)
        if (estadoAppX === "ediT" && modoEdicion === "manual") {

            if (editandoInput.id_input_editando !== null) {
                if (socket) {
                    socket.emit("A - editando registro", registro.id_partido_obra, registro)
                }
            }
        }
    }, [registro])

    useEffect(() => {
        if (socket) {

            const escuchandoNuevoEstado = (socket) => {

                setModoEdicion("remoto")

                console.log("RECIBEN TODOS MENOS EL QUE INICIO LA EDICION", socket)

                setRegistro(socket)
            }
            socket.on("C - array editando", escuchandoNuevoEstado)

            return () => {
                socket.off("C - array editando", escuchandoNuevoEstado)
            }
        }

    }, [registro])

    /* CHEQUEAR SI QUEDA #22FEB25
    useEffect(()=>{
        console.log("formRows ---> CAMBIO EN array_obras_expediente")
        if(estadoApp ==="ediT" && modoEdicion === "manual"){
            if(socket){
                socket.emit("Z - cambio en formRows", registro.id_partido_obra, formRows )
            }
        }

    },[formRows])
    */



    //NOTA 5-agos-2025: asegura que se ejecute el useEffect cuando es ediT y isInitialMount es true
    //al salir de la edicion, isInitialMount vuelve a ser true
    useEffect(() => {
        if (estadoAppX === "ediT" || estadoAppX === "edit_etapa2") {


            if (isInitialMount.current) {
                isInitialMount.current = false;
                return;
            }

            if (registro.programa_lineamiento) {
                setRegistro(prev => ({
                    ...prev,
                    modalidad: '' // Resetear modalidad
                }));
            }
        }
    }, [registro.programa_lineamiento])

    useEffect(() => {
        if (registro.lc_22_identificacion_catastral === 'NO') {
            setRegistro(prev => ({
                ...prev,
                lc_22_1_datos_catastrales: '' // Resetear datos catastrales
            }));
        }
    }, [registro.lc_22_identificacion_catastral])

    useEffect(() => {
        if (registro.barrio_tipo === 'RPPVAP') {
            setRegistro(prev => ({
                ...prev,
                barrio_otro_nombre: '' // Resetear nombre de barrio Otro
            }));
        } else if (registro.barrio_tipo === 'OTRO') {
            setRegistro(prev => ({
                ...prev,
                barrio_rppvap_nombre: null // Resetear selección RPPVAP
            }));
        } else if (registro.barrio_tipo === '' || registro.barrio_tipo === null) {
            setRegistro(prev => ({
                ...prev,
                barrio_otro_nombre: '',
                barrio_rppvap_nombre: null
            }));
        }
    }, [registro.barrio_tipo])

    //implementar un handler para escuchar localData desde formA handleSincronizarDatos
    const handleLocalDataChange = (localData) => {
        console.log('PUMA solo escuchar LocalData recibida desde formA:', localData);
        setEscuchandoLocalData(localData);
        // Aquí puedes actualizar el estado del padre con los datos locales
        //setRegistro(prev => ({ ...prev, ...localData }));
    };


    // Update the data for the table and store it in state for reference
    const handleDataLoaded = (data) => {
        setDataForTable(data);
        return data; // Return the data to allow chaining if needed
    };

    // Manejar aceptación de promoción (modal)
    const handleAceptarPromocion = () => {
        const idPartidoObra = pendingPromocion;
        if (!idPartidoObra) return;
        setPendingPromocion(null);
        const ref = promotionRef.current;
        ref.setIsEditing?.(false);
        const recargar = async () => {
            try {
                const integerId = ref.recordId || idPartidoObra;
                console.log('[recargar] idPartidoObra:', idPartidoObra, 'recordId:', ref.recordId, 'integerId:', integerId);
                const response = await fetch(`/api/obras/${integerId}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Socket-Id': socket?.id || '',
                        ...(ref.token ? { 'Authorization': `Bearer ${ref.token}` } : {})
                    }
                });
                const registroCompleto = await response.json();
                if (!response.ok || !registroCompleto || !registroCompleto.nombre_obra) {
                    console.warn('[recargar] Respuesta inválida, NO actualizando formA:', registroCompleto);
                    return;
                }
                const { array_tipo_subtipo_proyecto, array_obras_expediente, habilitar_multiples_partidos, partidos_multiples_jsonb, barrios_rppvap_multiples_jsonb, tipos_barrio_jsonb, barrios_renabap_multiples_jsonb, barrio_otro_nombre_jsonb, tipo_microcredito, ...restoDatos } = registroCompleto;
                ref.updateFormData?.('formA', {
                    datosGenerales: { ...restoDatos, tipo_microcredito: tipo_microcredito || null },
                    tipoSubtipoProyecto: Array.isArray(array_tipo_subtipo_proyecto) ? array_tipo_subtipo_proyecto : [{ tipo: '', subtipo: '', cantidad: '', unidad: '' }],
                    array_obras_expediente: Array.isArray(array_obras_expediente) ? array_obras_expediente : [],
                    habilitarMultiplesPartidos: habilitar_multiples_partidos || false,
                    partidosSeleccionados: partidos_multiples_jsonb || [],
                    barriosSeleccionados: barrios_rppvap_multiples_jsonb || [],
            tiposBarrioSeleccionados: tipos_barrio_jsonb || [],
            barriosRENABAPSeleccionados: barrios_renabap_multiples_jsonb || [],
            barrioOtroNombres: barrio_otro_nombre_jsonb || []
        });
                // El usuario promovido ya tiene los datos más recientes; limpiar banners de actualización pendiente
                setPendingUpdates(false);
                setLastUpdateInfo(null);
            } catch (err) {
                console.error('[recargar] Error:', err);
            }
            ref.getFormC_SeguimientoObra?.();
        };
        recargar();
    };

    // Manejar cancelación de promoción (modal)
    const handleCancelarPromocion = () => {
        const idPartidoObra = pendingPromocion;
        if (!idPartidoObra) return;
        setPendingPromocion(null);
        const ref = promotionRef.current;
        if (socket) {
            socket.emit("cancelar_promocion", idPartidoObra, ref.user);
        }
        ref.setIsEditing?.(true);
    };

    return (
        <>
            <div className="flex flex-row flex-auto justify-center items-center p-2 ">
                {(user === 'Javier' || user === 'Datos') && (
                    <>
                        <p>
                            User: {user}<br />
                            Estado X es: {estadoAppX}<br />
                            IsEditing: {isEditing}<br />
                            IsEditingProyectos: {isEditingProyectos}<br />
                            IsEditingPagos: {isEditingPagos}<br />
                            Pruebas X para pagina inicial `${estadoAppX === "ediT" || estadoAppX === "edit_etapa2" || estadoAppX === "nuevo" || estadoAppX === "nuevo_etapa2" ? "FORM=true" : "TABLE=true"}`<br />
                            {nueva_obra === true && estadoAppX === "inicial" ? `Nueva obra disponible. Cargar X` : ``}<br />
                            {modoEdicion}
                        </p>
                        <details className="mt-4 p-4 bg-gray-50 rounded-lg">
                            <summary className="font-medium text-gray-700 cursor-pointer">Datos del informe (depuración)</summary>
                            <pre>{JSON.stringify(array_obras_expediente, null, 2)}</pre>
                            <pre className="mt-2 p-2 bg-white border rounded overflow-auto max-h-40">
                                {JSON.stringify(tramitacionesExternas, null, 2)}
                            </pre>
                        </details>
                    </>
                )}
            </div>

            <div className="flex flex-col p-4 mb-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-800">
                <a
                    href="https://docs.google.com/spreadsheets/d/1kQ9YeNzulk6DFWxpAcTDM7oLfCpHVy722KNznL-g1_g/edit?gid=0#gid=0"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 font-medium transition-colors"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h2a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                    Beta: Informar errores/sugerencias
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
                        <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
                    </svg>
                </a>
                <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">¡Tu opinión nos ayuda a mejorar!</p>
            </div>

            {/* Banner de actualización manual cuando hay cambios remotos */}
            {(estadoAppX === "inicial" && pendingUpdates) && (
                <div className="mx-2 my-2 p-3 rounded-md bg-amber-100 border border-amber-300 flex items-center justify-between gap-3">
                    <div className="text-amber-900 text-sm">
                        {lastUpdateInfo?.type === 'created' && (
                            <>Nuevo proyecto disponible{lastUpdateInfo?.nombre_obra ? `: "${lastUpdateInfo.nombre_obra}"` : ''}{lastUpdateInfo?.by_user ? ` (por ${lastUpdateInfo.by_user})` : ''}.</>
                        )}
                        {lastUpdateInfo?.type === 'updated' && (
                            <>Se modificó proyecto{lastUpdateInfo?.nombre_obra ? `: "${lastUpdateInfo.nombre_obra}"` : ''}{lastUpdateInfo?.by_user ? ` (por ${lastUpdateInfo.by_user})` : ''}.</>
                        )}
                        {!lastUpdateInfo?.type && (
                            <>Hay cambios en obras{lastUpdateInfo?.nombre_obra ? `: "${lastUpdateInfo.nombre_obra}"` : ''}{lastUpdateInfo?.by_user ? ` (por ${lastUpdateInfo.by_user})` : ''}.</>
                        )}
                    </div>
                    <div className="flex items-center gap-2">
                        <Button onClick={applyPendingUpdates}>Actualizar datos</Button>
                        <button
                            onClick={() => setPendingUpdates(false)}
                            className="px-3 py-2 text-sm text-amber-900 hover:text-amber-700"
                        >
                            Ocultar
                        </button>
                    </div>
                </div>
            )}

            <div className="flex flex-col p-2 ">
                {(estadoAppX !== 'previewViabilidadTécnica' && estadoAppX !== 'previewInformeTecnicoObservaciones') && (
                    <Button type="submit" onClick={toggle}>
                        {estadoAppX === "inicial" ? "NUEVO PROYECTO" : "CANCELAR"}
                    </Button>
                )}
            </div>

            <div className={`${estadoAppX === 'inicial' ? "block" : "hidden"} w-full`}>
                <TablaInicioContainer
                    ref={tableInicioRef}
                    data={dataSemantica ?? data}
                    isLoading={loading}
                    onEditarRegistro={handleEditarRegistro}
                    setNewEditandoId={setNewEditandoId}
                    handlePreviewClick={handlePreviewClick}
                    arrayEditando={arrayEditando}
                    handleIsEditing={handleIsEditing}
                    onDataLoaded={handleDataLoaded}
                    onLiberarEdicion={handleLiberarEdicion}
                    onSoftDelete={handleSoftDelete}
                    busquedaSemanticaQuery={busquedaSemanticaQuery}
                    setBusquedaSemanticaQuery={setBusquedaSemanticaQuery}
                    onBusquedaSemantica={handleBusquedaSemantica}
                    onVerTodas={handleVerTodas}
                    buscandoSemantico={buscandoSemantico}
                    onAbrirBusquedaAvanzada={() => setAbrirBusquedaAvanzada(true)}
                    resultadosSemanticos={resultadosSemanticos}
                    onLimpiarSemantica={() => { setResultadosSemanticos(null); setBusquedaSemanticaQuery(''); }}
                    showValoracion={resultadosSemanticos !== null}
                    onValorar={handleValorar}
                    onToggleFeedback={() => setMostrarFeedback((v) => !v)}
                    onReindexarSemantico={handleReindexarSemantico}
                    reindexandoSemantico={reindexandoSemantico}
                />
                {mostrarFeedback && <BusquedaFeedback />}
            </div>
            <BusquedaAvanzadaModal
                isOpen={abrirBusquedaAvanzada}
                onClose={() => setAbrirBusquedaAvanzada(false)}
                consultaInicial={busquedaSemanticaQuery}
                onBuscar={handleBusquedaAvanzada}
            />

            <div className={`${(estadoAppX === 'nuevo' || estadoAppX === 'nuevo_etapa2' || estadoAppX === 'ediT' || estadoAppX === 'edit_etapa2' || estadoAppX === 'edit_desde_pagos' || estadoAppX === 'edit_desde_proyectos') ? "block" : "hidden"}`}>
                <div className="flex flex-col mb-6 p-4 bg-gray-100 dark:bg-gray-900 rounded-lg shadow-sm">
                    {(estadoAppX === 'ediT' || estadoAppX === 'edit_etapa2' || estadoAppX === 'edit_desde_pagos' || estadoAppX === 'edit_desde_proyectos') && (
                        (isEditingPagos === "true" || isEditingProyectos === "true" || isEditing)
                            ? <span className="text-red-600 dark:text-red-400">-MODO SOLO LECTURA- Este registro está siendo editado por otro usuario</span>
                            : ''
                    )}
                    {/* decidir mostrar según origen */}
                    {(estadoAppX === 'edit_desde_proyectos') && (
                        (isEditing === "true" || isEditingPagos === "true") 
                            ? <span className="text-red-600 dark:text-red-400">-MODO SOLO LECTURA- Este registro está siendo editado por otro usuario desde Tramitacion Proyectos</span>
                            : ''
                    )}

                    <EditExp id_tabla_obras={recordId} />
                    {role === 'admin' && obraId && (estadoAppX === 'ediT' || estadoAppX === 'edit_desde_pagos' || estadoAppX === 'edit_desde_proyectos') && (
                        <div className="px-4 pb-4">
                            <VersionHistory obraId={obraId} cg01IdPartidoObra={cg01IdPartidoObra} />
                        </div>
                    )}
                </div>
            </div>

            <div className={`${estadoAppX === 'previewInformeTecnicoObservaciones' ? "block" : "hidden"}`}>
                <div className="flex flex-col mb-6 p-4 bg-white dark:bg-gray-900 rounded-lg shadow-sm">
                    {(deDondeViene === "ediT" || deDondeViene === "edit_desde_pagos" || deDondeViene === "edit_desde_proyectos") ? (
                        <button
                            onClick={() => cambiarEstadoApp(deDondeViene)}
                            className="mb-4 px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-md self-start"
                        >
                            ← Volver a Edición
                        </button>
                    ) : (
                        <button
                            onClick={() => cambiarEstadoApp('inicial')}
                            className="mb-4 px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-md self-start"
                        >
                            ← Volver a la tabla
                        </button>
                    )}
                    <PreviewPDF />
                </div>
            </div>

            {estadoAppX === 'previewViabilidadTécnica' && (<div className={`${estadoAppX === 'previewViabilidadTécnica' ? "block" : "hidden"}`}>
                <div className="flex flex-col mb-6 p-4 bg-white dark:bg-gray-900 rounded-lg shadow-sm">
                    {deDondeViene === "nuevo" && (
                        <button
                            onClick={() => cambiarEstadoApp('nuevo')}
                            className="mb-4 px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-md self-start"
                        >
                            ← Volver a Nuevo
                        </button>
                    )}
                    {(deDondeViene === "ediT" || deDondeViene === "edit_desde_pagos" || deDondeViene === "edit_desde_proyectos") && (
                        <button
                            onClick={() => cambiarEstadoApp(deDondeViene)}
                            className="mb-4 px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-md self-start"
                        >
                            ← Volver a Edición
                        </button>
                    )}
                    <PreviewAndDownloadPDFReport data={formA} />{/*data={registro}*/}
                </div>

            </div>)}

            {/* El chat de soporte (TelegramModal) se monta en LayoutPriv, para
                que el botón esté disponible desde cualquier pantalla y no solo
                desde Inicio. */}
            <div className={`${estadoAppX === 'inicial'
                ? "bg-white dark:bg-gray-800 pointer-events-none fixed inset-x-0 bottom-0"
                : "bg-green-300 dark:bg-green-700 fixed inset-x-0 bottom-0"}`}>
                <div className="flex flex-col md:flex-row gap-4 justify-center items-center bg-white dark:bg-gray-800 p-2 border-t border-gray-200 dark:border-gray-700">

                    {(
                        estadoAppX !== 'inicial' &&
                        estadoAppX !== 'previewViabilidadTécnica' &&
                        estadoAppX !== 'previewInformeTecnicoObservaciones'
                    ) && ( //Muestra los botones de guardar solo si no está en estado inicial // reponer: || !formularioEsValido
                            <>
                                <Button type="submit" onClick={redirect_Cont} disabled={isSavingCont || isSavingExit || isEditing || isEditingPagos === "true" || isEditingProyectos === "true" || !formularioEsValido || expedienteDuplicado || expedienteIncompleto}>

                                    {isSavingCont ? "en progreso.." : "GUARDAR y CONTINUAR"}

                                </Button>
                                <Button type="submit" onClick={redirect} disabled={isSavingExit || isSavingCont || isEditing || isEditingPagos === "true" || isEditingProyectos === "true" || !formularioEsValido || expedienteDuplicado || expedienteIncompleto}>

                                    {isSavingExit ? "en progreso.." : "GUARDAR y SALIR"}

                                </Button>
                                <Button type="submit" onClick={toggle} disabled={isSavingCont || isSavingExit}>CANCELAR</Button>
                            </>
                        )}

                </div>
            </div>

            {/* Modal de promoción (reemplaza window.confirm que Chrome suprime en eventos asíncronos) */}
            {pendingPromocion && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-6 max-w-md mx-4 shadow-xl">
                        <h3 className="text-lg font-semibold mb-4">Permisos de edición</h3>
                        <p className="mb-6">Ahora tienes permisos de edición. ¿Quieres asumir la edición y cargar la última versión de los datos?</p>
                        <div className="flex gap-3 justify-end">
                            <button
                                onClick={handleCancelarPromocion}
                                className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-md"
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={handleAceptarPromocion}
                                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md"
                            >
                                Aceptar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de solo_lectura: se muestra cuando el usuario abre un registro que otro está editando */}
            {showSoloLecturaModal && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-6 max-w-md mx-4 shadow-xl">
                        <h3 className="text-lg font-semibold mb-4 text-amber-700">Modo solo lectura</h3>
                        <p className="mb-2">Este registro está siendo editado por otro usuario.</p>
                        <p className="mb-6 text-sm text-gray-600">Podés ver los datos pero no realizar cambios hasta que el editor actual libere la edición.</p>
                        <div className="flex justify-end">
                            <button
                                onClick={() => setShowSoloLecturaModal(false)}
                                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md"
                            >
                                Entendido
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {mostrandoCancelConfirm && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-6 max-w-md mx-4 shadow-xl max-h-[80vh] overflow-y-auto">
                        <h3 className="text-lg font-semibold mb-4 text-amber-700">Cambios sin guardar</h3>
                        <p className="mb-4">Hay cambios aún sin guardar. Al cancelar la edición se van a perder. ¿Continuar...?</p>
                        {(() => {
                            const sectionLabels = { formA: 'Características generales', formB_main: 'Tramitación', formB_observaciones: 'Tramitación — Observaciones', formB_expedienteProyecto: 'Tramitación — Expediente proyecto', formC_main: 'Seguimiento', formC_pagos: 'Seguimiento — Pagos', formC_mediciones: 'Seguimiento — Mediciones', formC_mejoras: 'Seguimiento — Mejoras', formC_geometries: 'Seguimiento — Geometrías', formC_beneficiarios: 'Seguimiento — Beneficiarios', formC_circuitoAdmin: 'Seguimiento — Circuito administrativo' };
                            const fieldLabels = {
                                'formA.tipoSubtipoProyecto': 'Tipo de proyecto',
                                'formA.datosGenerales.expediente': 'Expediente',
                                'formA.datosGenerales.registro': 'Registro',
                                'formA.datosGenerales.nombre_obra': 'Nombre de obra',
                                'formA.datosGenerales.area_responsable': 'Área responsable',
                                'formA.datosGenerales.programa_lineamiento': 'Programa / Lineamiento',
                                'formA.datosGenerales.modalidad': 'Modalidad',
                                'formA.datosGenerales.monto_obra': 'Monto de obra',
                                'formA.datosGenerales.expediente_proyecto': 'Expediente del proyecto',
                                'formA.datosGenerales.fecha_ingreso': 'Fecha de ingreso',
                                'formA.datosGenerales.fecha_paralizacion': 'Fecha de paralización',
                                'formA.datosGenerales.codigo_obra': 'Código de obra',
                                'formA.datosGenerales.fecha_actualizacion': 'Fecha de actualización',
                                'formA.array_obras_expediente': 'Obras del expediente',
                                'formA.arrayBeneficiarios': 'Beneficiarios',
                                'formA.datosGenerales.id_obra': 'ID de obra',
                                'formA.datosGenerales.id_origen': 'ID de origen',
                                'formA.datosGenerales.id_partido_obra': 'ID de partido obra',
                                'formB.numero_expediente': 'Número de expediente',
                                'formB.expedienteProyecto': 'Documentación del proyecto',
                                'formB.selectedRequisitos': 'Requisitos seleccionados',
                                'formB.internasHistorico': 'Tramitaciones internas',
                                'formB.tramitacionesInternas': 'Tramitaciones internas',
                                'formB.observaciones': 'Observaciones',
                                'formC.arrayPagosMejoras': 'Pagos — Mejoras',
                                'formC.arrayPagosMicrocreditos': 'Pagos — Microcréditos',
                                'formC.arrayPagosProyectos': 'Pagos — Proyectos',
                                'formC.arrayPagosIntervencionSocial': 'Pagos — Intervención Social',
                                'formC.arrayPagosCapacitaciones': 'Pagos — Capacitaciones',
                                'formC.porcentaje_parcial_2do_pago': '2º pago parcial',
                                'formC.porcentaje_parcial_3er_pago': '3º pago parcial',
                                'formC.porcentaje_gastos_operativos': '% Gastos operativos',
                                'formC.arrayMediciones': 'Mediciones',
                                'formC.arrayMejorasEtapaI': 'Mejoras — Etapa I',
                                'formC.arrayMejorasEtapaII': 'Mejoras — Etapa II',
                                'formC.arrayCircuitoAdmin': 'Circuito administrativo',
                                'formC.seguimientoObra': 'Observaciones del seguimiento de obra',
                                'formC.seguimientoObra.estado': 'Estado del seguimiento',
                                'formC.seguimientoObra.observaciones': 'Observaciones del seguimiento',
                                'formC.seguimientoObra.fecha': 'Fecha del seguimiento',
                                'formC.arrayMediciones': 'Tabla de mediciones',
                                'formC_mediciones': 'Tabla de mediciones',
                                'formC_pagos': 'Sección de pagos',
                                'formC_mejoras': 'Sección de mejoras',
                                'formC_circuitoAdmin': 'Circuito administrativo',
                                'formC_geometries': 'Geometrías',
                                'formC_beneficiarios': 'Beneficiarios',
                                'formC_main': 'Seguimiento',
                                'formB_main': 'Tramitación',
                                'formB_observaciones': 'Tramitación — Observaciones',
                                'formB_expedienteProyecto': 'Tramitación — Expediente proyecto',
                                'formA': 'Características generales',
                            };
                            const dirtyKeys = Object.keys(dirtyFields);
                            return (
                                <details className="mb-4 text-sm text-gray-600">
                                    <summary className="cursor-pointer font-medium text-gray-700 hover:text-gray-900">
                                        Ver detalle de cambios
                                    </summary>
                                    <div className="mt-2 space-y-3">
                                        {Object.entries(sectionLabels).filter(([k]) => dirtySections[k]).map(([secKey, secLabel]) => {
                                            const fieldKeysInSection = dirtyKeys.filter(k => {
                                                if (k === secKey) return true;
                                                if (secKey === 'formA') return k.startsWith('formA.');
                                                if (secKey === 'formB_main') return (k.startsWith('formB.') && !k.includes('internasHistorico') && !k.includes('expedienteProyecto') && !k.includes('selectedRequisitos')) || k === 'formB_main';
                                                if (secKey === 'formB_observaciones') return k.includes('internasHistorico') || k.includes('observacion') || k === 'formB_observaciones';
                                                if (secKey === 'formB_expedienteProyecto') return k.includes('expedienteProyecto') || k === 'formB_expedienteProyecto';
                                                if (secKey === 'formC_pagos') return k.includes('arrayPagos') || k.includes('porcentaje') || k === 'formC_pagos';
                                                if (secKey === 'formC_mediciones') return k.includes('arrayMediciones') || k === 'formC_mediciones';
                                                if (secKey === 'formC_mejoras') return k.includes('arrayMejoras') || k === 'formC_mejoras';
                                                if (secKey === 'formC_circuitoAdmin') return k.includes('arrayCircuito') || k === 'formC_circuitoAdmin';
                                                if (secKey === 'formC_geometries') return k.includes('geometries') || k === 'formC_geometries';
                                                if (secKey === 'formC_beneficiarios') return k.includes('arrayBeneficiarios') || k === 'formC_beneficiarios';
                                                if (secKey === 'formC_main') return k === 'formC_main' || k.startsWith('formC.seguimientoObra') || (k.startsWith('formC.') && !k.includes('arrayPagos') && !k.includes('arrayMediciones') && !k.includes('arrayMejoras') && !k.includes('arrayCircuito') && !k.includes('porcentaje') && !k.includes('arrayBeneficiarios') && !k.includes('geometries'));
                                                return false;
                                            });
                                            if (fieldKeysInSection.length === 0) return null;
                                            const uniqueFields = [...new Set(fieldKeysInSection)];
                                            return (
                                                <div key={secKey}>
                                                    <p className="font-medium text-gray-800">{secLabel}</p>
                                                    <ul className="ml-3 mt-1 space-y-0.5 list-disc list-inside text-gray-500">
                                                        {uniqueFields.map(fk => (
                                                            <li key={fk}>{fieldLabels[fk] || fk.split('.').slice(1).join(' \u2192 ')}</li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </details>
                            );
                        })()}
                        <div className="flex gap-3 justify-end">
                            <button
                                onClick={() => setMostrandoCancelConfirm(false)}
                                className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-md"
                            >
                                Volver
                            </button>
                            <button
                                onClick={() => { setMostrandoCancelConfirm(false); ejecutarCancelacion(); }}
                                className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md"
                            >
                                Continuar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {edicionCambioPending && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
                    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl p-6 max-w-md mx-4">
                        <h3 className="text-lg font-semibold mb-3 text-amber-700">Ya estás editando otra obra</h3>
                        <p className="mb-2 text-gray-700 dark:text-gray-200">
                            Estás editando la obra <strong>{edicionCambioPending.idObraAnterior}</strong>.
                        </p>
                        <p className="mb-4 text-gray-700 dark:text-gray-200">
                            Al abrir la obra <strong>{edicionCambioPending.registro?.id_partido_obra}</strong> se va a
                            liberar la edición anterior y los cambios sin guardar en ella se perderán.
                        </p>
                        <div className="flex gap-3 justify-end">
                            <button
                                onClick={cancelarCambioObra}
                                className="px-4 py-2 bg-gray-200 hover:bg-gray-300 dark:bg-gray-600 dark:hover:bg-gray-500 rounded-md"
                            >
                                Volver
                            </button>
                            <button
                                onClick={confirmarCambioObra}
                                className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md"
                            >
                                Continuar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {modalAccion && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
                    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl p-8 flex flex-col items-center gap-4">
                        <svg className="animate-spin h-10 w-10 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                        </svg>
                        <p className="text-lg font-semibold text-gray-800 dark:text-gray-100">
                            {modalAccion === "guardar_y_salir" && "Guardando y actualizando datos..."}
                            {modalAccion === "guardar_y_continuar" && "Actualizando datos..."}
                            {modalAccion === "cancelar" && "Cancelando..."}
                        </p>
                    </div>
                </div>
            )}

            {/* Modal de carga de datos al editar desde pagos (estado edit_desde_pagos, p.ej. doble click desde Análisis de Pagos) */}
            {cargandoDatos && estadoAppX === 'edit_desde_pagos' && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
                    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl p-8 flex flex-col items-center gap-4">
                        <svg className="animate-spin h-10 w-10 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                        </svg>
                        <p className="text-lg font-semibold text-gray-800 dark:text-gray-100">Cargando datos...</p>
                    </div>
                </div>
            )}

            <ToastContainer />

        </>

    )
}

export const InicioPage = React.memo(InicioPageComponente);
